// 八字分析弹窗类 - Shopify兼容版本
class BaziPopup {
  constructor() {
    this.popup = null;
    this.form = null;
    this.formSection = null;
    this.loadingSection = null;
    this.resultSection = null;
    this.currentStep = 0;
    this.debugMode = true;
    
    // 地理位置相关
    this.birthplaceInput = null;
    this.autocompleteResults = null;
    this.geolocationData = null;
    this.activeAutocompleteIndex = -1;
    this.cityData = [];
    
    // 配置信息
    this.aiConfig = {
      useAI: false, // 只使用本地计算
      apiKey: '', // 在Shopify中使用时，建议通过环境变量或应用配置获取
      apiEndpoint: 'https://api.openai.com/v1/chat/completions'
    };
    
    this.productConfig = {
      source: 'dom',
      useMetafields: true,
      baziMetafields: {
        element: 'data-metafield-bazi-element',
        luckyElement: 'data-metafield-bazi-lucky-element',
        effect: 'data-metafield-bazi-effect',
        wealthLuck: 'data-metafield-bazi-wealth-luck',
        careerLuck: 'data-metafield-bazi-career-luck',
        loveLuck: 'data-metafield-bazi-love-luck',
        healthLuck: 'data-metafield-bazi-health-luck',
        currentYearLuck: 'data-metafield-bazi-current-year-luck'
      },
      colorTagMap: {
        '金': ['金', 'gold', 'golden', 'white', 'silver'],
        '木': ['木', 'wood', 'green'],
        '水': ['水', 'water', 'black', 'blue'],
        '火': ['火', 'fire', 'red', 'orange'],
        '土': ['土', 'earth', 'yellow', 'brown']
      }
    };
    
    // 初始化弹窗
    this.init();
  }

  // 主要城市列表作为fallback
  getMainCities() {
    return [
      // China
      'Beijing, Beijing, China',
      'Shanghai, Shanghai, China',
      'Guangzhou, Guangdong, China',
      'Shenzhen, Guangdong, China',
      'Hangzhou, Zhejiang, China',
      'Chengdu, Sichuan, China',
      'Nanjing, Jiangsu, China',
      'Wuhan, Hubei, China',
      'Xi\'an, Shaanxi, China',
      'Chongqing, Chongqing, China',
      // Other Asian countries
      'Tokyo, Tokyo, Japan',
      'Osaka, Osaka, Japan',
      'Seoul, Seoul, South Korea',
      'Singapore, Singapore, Singapore',
      'Bangkok, Bangkok, Thailand',
      'Mumbai, Maharashtra, India',
      // North America
      'New York, New York, USA',
      'Los Angeles, California, USA',
      'Chicago, Illinois, USA',
      'Toronto, Ontario, Canada',
      // Europe
      'London, England, UK',
      'Paris, Ile-de-France, France',
      'Berlin, Berlin, Germany',
      'Rome, Lazio, Italy',
      'Madrid, Madrid, Spain',
      // Oceania
      'Sydney, New South Wales, Australia',
      'Melbourne, Victoria, Australia',
      // South America
      'Sao Paulo, Sao Paulo, Brazil',
      'Buenos Aires, Buenos Aires, Argentina',
      // Africa
      'Cairo, Cairo, Egypt',
      'Johannesburg, Gauteng, South Africa'
    ];
  }

  // 使用Nominatim地理编码服务搜索城市
  async searchCities(query) {
    try {
      const encodedQuery = encodeURIComponent(query);
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodedQuery}&limit=20&addressdetails=1`;
      
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'User-Agent': 'BaziPopup/1.0'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        console.error('城市搜索失败:', response.status);
        // 使用内置城市列表作为fallback
        return this.getMainCities().filter(city => 
          city.toLowerCase().includes(query.toLowerCase())
        ).map(city => ({ display_name: city }));
      }
    } catch (error) {
      console.error('搜索城市时出错:', error);
      // 使用内置城市列表作为fallback
      return this.getMainCities().filter(city => 
        city.toLowerCase().includes(query.toLowerCase())
      ).map(city => ({ display_name: city }));
    }
  }

  // 初始化弹窗
  init() {
    // 创建弹窗HTML结构
    this.createPopup();
    // 绑定事件
    this.bindEvents();
    // 添加到页面
    this.addToPage();
    
    console.log('八字弹窗初始化完成');
  }
  
  // 创建弹窗HTML结构
  createPopup() {
    const popupHTML = `
      <div id="bazi-popup" class="bazi-popup">
        <div class="bazi-popup-overlay"></div>
        <div class="bazi-popup-content">
          <!-- 弹窗头部 -->
          <div class="bazi-popup-header">
            <h2>Bazi Analysis</h2>
            <button id="bazi-close" class="bazi-close-btn">&times;</button>
          </div>
          
          <!-- 表单部分 -->
          <div id="bazi-form-section" class="bazi-section">
            <form id="bazi-form">
              <!-- 基本信息 -->
              <div class="bazi-form-group">
                <label for="gender">Gender</label>
                <select id="gender" name="gender" required>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              
              <div class="bazi-form-row">
                <div class="bazi-form-group">
                  <label for="birthdate">Date of Birth</label>
                  <input type="date" id="birthdate" name="birthdate" required>
                </div>
                
                <div class="bazi-form-group">
                  <label for="birthtime">Time of Birth</label>
                  <select id="birthtime" name="birthtime" required>
                    <option value="0">0:00</option>
                    <option value="1">1:00</option>
                    <option value="2">2:00</option>
                    <option value="3">3:00</option>
                    <option value="4">4:00</option>
                    <option value="5">5:00</option>
                    <option value="6">6:00</option>
                    <option value="7">7:00</option>
                    <option value="8">8:00</option>
                    <option value="9">9:00</option>
                    <option value="10">10:00</option>
                    <option value="11">11:00</option>
                    <option value="12">12:00</option>
                    <option value="13">13:00</option>
                    <option value="14">14:00</option>
                    <option value="15">15:00</option>
                    <option value="16">16:00</option>
                    <option value="17">17:00</option>
                    <option value="18">18:00</option>
                    <option value="19">19:00</option>
                    <option value="20">20:00</option>
                    <option value="21">21:00</option>
                    <option value="22">22:00</option>
                    <option value="23">23:00</option>
                  </select>
                </div>
              </div>
              
              <div class="bazi-form-group">
                <label for="birthplace">Place of Birth</label>
                <div class="bazi-autocomplete-container">
                  <input type="text" id="birthplace" name="birthplace" placeholder="e.g.: Beijing" required>
                  <div id="bazi-autocomplete-results" class="bazi-autocomplete-results"></div>
                </div>
              </div>
              
              <div class="bazi-form-group">
                <label for="relationship">Relationship Status</label>
                <select id="relationship" name="relationship" required>
                  <option value="single">Single</option>
                  <option value="in-relationship">In a Relationship</option>
                  <option value="just-broke-up">Just Broke Up</option>
                  <option value="engaged">Engaged</option>
                  <option value="married">Married</option>
                  <option value="looking-for-soulmate">Looking for Soulmate</option>
                  <option value="complicated">It's Complicated</option>
                </select>
              </div>
              
              <!-- 提交按钮 -->
              <button type="submit" class="bazi-submit-btn">Start Analysis</button>
            </form>
          </div>
          
          <!-- 加载状态 -->
          <div id="bazi-loading-section" class="bazi-section bazi-hidden">
            <div class="bazi-loading">
              <div class="bazi-loading-spinner"></div>
              <p>Analyzing your Bazi...</p>
            </div>
          </div>
          
          <!-- 结果展示 -->
          <div id="bazi-result-section" class="bazi-section bazi-hidden">
            <!-- 基本信息 -->
            <div class="bazi-result-header">
              <h3>Analysis Results</h3>
            </div>
            
            <div class="bazi-result-basic">
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Gender：</span>
                  <span id="result-gender">Male</span>
                </div>
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Date of Birth：</span>
                  <span id="result-birthdate">1990-01-01</span>
                </div>
              </div>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Time of Birth：</span>
                  <span id="result-birthtime">12:00</span>
                </div>
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Place of Birth：</span>
                  <span id="result-birthplace">Beijing</span>
                </div>
              </div>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Relationship Status：</span>
                  <span id="result-relationship">Single</span>
                </div>
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Chinese Zodiac：</span>
                  <span id="result-zodiac">Snake</span>
                </div>
              </div>
            </div>
            
            <!-- 八字信息 -->
            <div class="bazi-result-bazi">
              <h4>Bazi Information</h4>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Bazi：</span>
                  <span id="result-bazi">庚午 己丑 丙申 辛卯</span>
                </div>
              </div>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Five Elements Distribution：</span>
                  <span id="result-elements">Metal: 2 | Wood: 1 | Water: 1 | Fire: 2 | Earth: 2</span>
                </div>
              </div>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Five Elements Preference：</span>
                  <span id="result-element-preference">Lucky: Metal、Water | Unlucky: Wood、Fire</span>
                </div>
              </div>
              <div class="bazi-result-row">
                <div class="bazi-result-item">
                  <span class="bazi-result-label">Lucky Colors：</span>
                  <span id="result-lucky-colors">White、Gold、Black、Blue</span>
                </div>
              </div>
            </div>
            
            <!-- 详细分析 -->
            <div class="bazi-result-detail">
              <h4>Detailed Analysis</h4>
              
              <!-- 八字结构分析 -->
              <div class="bazi-analysis-section">
                <h5>Bazi Structure Analysis</h5>
                <div id="result-structure-analysis" class="bazi-analysis-content">
                  <p>1. Bazi Structure Analysis：</p>
                  <p>2. Five Elements Strength Analysis：</p>
                  <p>3. Ten Gods Analysis：</p>
                  <p>4. Pattern Analysis：</p>
                </div>
              </div>
              
              <!-- 综合分析 -->
              <div class="bazi-analysis-section">
                <h5>Comprehensive Analysis</h5>
                <div id="result-comprehensive-analysis" class="bazi-analysis-content">
                  <p>1. Bazi Comprehensive Analysis：</p>
                </div>
              </div>
              
              <!-- 性格分析 -->
              <div class="bazi-analysis-section">
                <h5>Personality Analysis</h5>
                <div id="result-personality-analysis" class="bazi-analysis-content">
                  <p>1. You are an outgoing, enthusiastic person who enjoys communicating and sharing with others.</p>
                  <p>2. You have strong leadership and organizational skills, suitable for management work.</p>
                  <p>3. You are serious and responsible in your work, paying attention to details, with a strong sense of responsibility.</p>
                </div>
              </div>
              
              <!-- 事业运分析 -->
              <div class="bazi-analysis-section">
                <h5>Career Fortune Analysis</h5>
                <div id="result-career-analysis" class="bazi-analysis-content">
                  <p>1. Your career fortune is generally good, with strong work ability and ambition.</p>
                  <p>2. Suitable for careers related to Metal, such as finance, investment, and management.</p>
                  <p>3. This year, your career development is smooth, with opportunities for promotion or salary increase.</p>
                </div>
              </div>
              
              <!-- 财运分析 -->
              <div class="bazi-analysis-section">
                <h5>Wealth Fortune Analysis</h5>
                <div id="result-wealth-analysis" class="bazi-analysis-content">
                  <p>1. Your wealth fortune is relatively stable, suitable for increasing wealth through investment and financial management.</p>
                  <p>2. This year's wealth fortune is good, with opportunities for unexpected gains.</p>
                  <p>3. It is recommended to pay more attention to the financial market and seize investment opportunities.</p>
                </div>
              </div>
              
              <!-- 感情运分析 -->
              <div class="bazi-analysis-section">
                <h5>Relationship Fortune Analysis</h5>
                <div id="result-love-analysis" class="bazi-analysis-content">
                  <p>1. Your relationship fortune is generally good, easily attracting the attention of the opposite sex.</p>
                  <p>2. You are currently single, with many opportunities to meet new people.</p>
                  <p>3. It is recommended to participate in more social activities and expand your social circle.</p>
                </div>
              </div>
              
              <!-- 健康运分析 -->
              <div class="bazi-analysis-section">
                <h5>Health Fortune Analysis</h5>
                <div id="result-health-analysis" class="bazi-analysis-content">
                  <p>1. Your overall health condition is good, it is recommended to maintain good living habits.</p>
                  <p>2. Pay attention to protecting liver and eye health, avoid staying up late and excessive eye use.</p>
                  <p>3. It is recommended to have regular physical examinations to timely detect and adjust health problems.</p>
                </div>
              </div>
              
              <!-- 今年运势分析 -->
              <div class="bazi-analysis-section">
                <h5>Current Year Fortune Analysis</h5>
                <div id="result-current-year-analysis" class="bazi-analysis-content">
                  <p>1. This year's overall fortune is relatively stable, need to grasp opportunities and actively advance.</p>
                  <p>2. This year is a Fire year, Metal element is restrained, need to pay attention to adjusting your fortune.</p>
                  <p>3. It is recommended to wear gold or white, gold-colored accessories, which help to improve fortune.</p>
                </div>
              </div>
              
              <!-- 最近运势分析 -->
              <div class="bazi-analysis-section">
                <h5>Recent Fortune Analysis</h5>
                <div id="result-recent-luck-analysis" class="bazi-analysis-content">
                  <p>1. Recent fortune is relatively stable, suitable for steady development.</p>
                  <p>2. Conducive to stable development and experience accumulation, preparing for long-term development.</p>
                  <p>3. Recently need to pay attention to emotion management, avoid impulsive decisions.</p>
                </div>
              </div>
              
              <!-- 需要注意和调节的地方 -->
              <div class="bazi-analysis-section">
                <h5>Points to Note and Adjustments</h5>
                <div id="result-notice-points-analysis" class="bazi-analysis-content">
                  <p>1. The following are areas you need to pay special attention to and adjust：</p>
                  <p>2. Pay attention to protecting liver and eye health, avoid staying up late and excessive eye use.</p>
                  <p>3. Avoid impulsive decisions, think carefully about things.</p>
                </div>
              </div>
              
              <!-- 化解建议和开运方法 -->
              <div class="bazi-analysis-section">
                <h5>Resolution Suggestions and Fortune-Enhancing Methods</h5>
                <div id="result-resolution-analysis" class="bazi-analysis-content">
                  <p>1. The following are some suggestions to resolve unfavorable factors and improve fortune：</p>
                  <p>2. You can wear gold jewelry or white, gold-colored accessories, which help to improve fortune.</p>
                  <p>3. Place metal ornaments in your home or office, such as copper bells, metal vases, etc.</p>
                </div>
              </div>
            </div>
            
            <!-- 重新分析按钮 -->
            <div class="bazi-result-actions">
              <button id="bazi-restart-btn" class="bazi-restart-btn">Restart Analysis</button>
            </div>
          </div>
          
          <!-- 弹窗触发按钮 -->
          <button id="bazi-trigger-btn" class="bazi-trigger-btn">Bazi Analysis</button>
    `;
    
    // 创建样式
    const style = document.createElement('style');
    style.textContent = `
      /* 八字弹窗样式 */
      .bazi-popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
      .bazi-popup-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(5px);
      }
      
      .bazi-popup-content {
        position: relative;
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        width: 90%;
        max-width: 600px;
        max-height: 90vh;
        overflow-y: auto;
      }
      
      .bazi-popup-header {
        padding: 20px;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      
      .bazi-popup-header h2 {
        margin: 0;
        font-size: 20px;
        color: #333;
      }
      
      .bazi-close-btn {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #999;
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.3s ease;
      }
      
      .bazi-close-btn:hover {
        background-color: #f0f0f0;
        color: #333;
      }
      
      /* 表单样式 */
      .bazi-section {
        padding: 20px;
      }
      
      .bazi-hidden {
        display: none !important;
      }
      
      .bazi-form-group {
        margin-bottom: 16px;
      }
      
      .bazi-form-row {
        display: flex;
        gap: 16px;
      }
      
      .bazi-form-row .bazi-form-group {
        flex: 1;
      }
      
      .bazi-form-group label {
        display: block;
        margin-bottom: 6px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
      
      .bazi-form-group input,
      .bazi-form-group select {
        width: 100%;
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        font-size: 14px;
        transition: border-color 0.3s ease;
      }
      
      .bazi-form-group input:focus,
      .bazi-form-group select:focus {
        outline: none;
        border-color: #007cba;
      }
      
      .bazi-submit-btn {
        width: 100%;
        padding: 12px;
        background-color: #007cba;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.3s ease;
      }
      
      .bazi-submit-btn:hover {
        background-color: #005a87;
      }
      
      /* 加载状态 */
      .bazi-loading {
        text-align: center;
        padding: 40px 0;
      }
      
      .bazi-loading-spinner {
        width: 40px;
        height: 40px;
        margin: 0 auto 16px;
        border: 4px solid #f0f0f0;
        border-top-color: #007cba;
        border-radius: 50%;
        animation: bazi-spin 1s linear infinite;
      }
      
      @keyframes bazi-spin {
        to { transform: rotate(360deg); }
      }
      
      .bazi-loading p {
        color: #666;
        font-size: 14px;
      }
      
      /* 结果展示 */
      .bazi-result-header h3 {
        margin: 0 0 20px 0;
        font-size: 18px;
        color: #333;
      }
      
      .bazi-result-basic,
      .bazi-result-bazi {
        background-color: #fafafa;
        padding: 16px;
        border-radius: 8px;
        margin-bottom: 20px;
      }
      
      .bazi-result-row {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 12px;
      }
      
      .bazi-result-item {
        flex: 1;
        min-width: 200px;
        font-size: 14px;
      }
      
      .bazi-result-label {
        font-weight: 500;
        color: #666;
      }
      
      /* 分析内容 */
      .bazi-result-detail h4 {
        margin: 0 0 16px 0;
        font-size: 16px;
        color: #333;
      }
      
      .bazi-analysis-section {
        margin-bottom: 24px;
        padding: 16px;
        background-color: #fafafa;
        border-radius: 8px;
      }
      
      .bazi-analysis-section h5 {
        margin: 0 0 12px 0;
        font-size: 15px;
        color: #333;
      }
      
      .bazi-analysis-content {
        font-size: 14px;
        line-height: 1.6;
        color: #444;
      }
      
      .bazi-analysis-content p {
        margin: 8px 0;
      }
      
      /* 产品推荐样式 */
      .bazi-recommendation-section {
        margin: 15px 0;
        padding: 15px;
        background-color: #ffffff;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }
      
      .bazi-product-card {
        width: 140px;
        border: 1px solid #e8e8e8;
        border-radius: 10px;
        padding: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        height: auto;
        min-height: 220px;
      }
      
      .bazi-product-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        border-color: #d0d0d0;
      }
      
      .bazi-product-image {
        width: 100%;
        height: 90px;
        object-fit: cover;
        border-radius: 6px;
        margin-bottom: 10px;
        background-color: #fafafa;
      }
      
      .bazi-product-info {
        font-size: 14px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      
      .bazi-product-title {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      
      .bazi-product-price {
        margin: 0 0 8px 0;
        font-size: 15px;
        font-weight: 600;
        color: #e53e3e;
      }
      
      .bazi-product-reasons {
        font-size: 12px;
        margin-top: auto;
        padding-top: 8px;
        border-top: 1px solid #f0f0f0;
      }
      
      .bazi-product-reasons p {
        margin: 0;
        color: #666;
        line-height: 1.5;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      
      /* 重新分析按钮 */
      .bazi-result-actions {
        text-align: center;
        margin-top: 24px;
      }
      
      .bazi-restart-btn {
        padding: 10px 20px;
        background-color: #f0f0f0;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s ease;
      }
      
      .bazi-restart-btn:hover {
        background-color: #e0e0e0;
      }
      
      /* 触发按钮样式 */
      .bazi-trigger-btn {
        position: fixed;
        bottom: 30px;
        right: 30px;
        background-color: #007cba;
        color: white;
        border: none;
        border-radius: 50px;
        padding: 12px 24px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        transition: all 0.3s ease;
        z-index: 9998;
      }
      
      .bazi-trigger-btn:hover {
        background-color: #005a87;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
      }
      
      /* 自动完成容器 */
      .bazi-autocomplete-container {
        position: relative;
        display: flex;
        flex-direction: column;
      }
      
      /* 自动完成结果列表 */
      .bazi-autocomplete-results {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background-color: #ffffff;
        border: 1px solid #e2e8f0;
        border-top: none;
        border-radius: 0 0 8px 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        display: none;
      }
      
      .bazi-autocomplete-results.active {
        display: block;
      }
      
      /* 自动完成结果项 */
      .bazi-autocomplete-item {
        padding: 12px 16px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
        transition: background-color 0.2s ease;
      }
      
      .bazi-autocomplete-item:hover,
      .bazi-autocomplete-item.active {
        background-color: #f0f4f8;
        color: #6b46c1;
      }
      
      /* 自动完成结果项高亮 */
      .bazi-autocomplete-item .highlight {
        font-weight: 600;
        color: #6b46c1;
      }
      
      /* 移动端适配 */
      @media (max-width: 768px) {
        .bazi-form-row {
          flex-direction: column;
        }
        
        .bazi-result-row {
          flex-direction: column;
        }
        
        .bazi-result-item {
          min-width: auto;
        }
        
        .bazi-popup-content {
          width: 95%;
        }
        
        .bazi-product-card {
          width: 130px;
        }
      }
    `;
    
    // 创建弹窗元素
    if (!document.querySelector("#bazi-popup")) {
      const div = document.createElement('div');
      div.innerHTML = popupHTML;
      this.popup = div.firstElementChild;
      // 添加样式到页面
      document.head.appendChild(style);
    } else {
      this.popup = document.querySelector("#bazi-popup");
    }
    
    // 初始化表单和各部分
    this.form = this.popup.querySelector('#bazi-form');
    this.formSection = this.popup.querySelector('#bazi-form-section');
    this.loadingSection = this.popup.querySelector('#bazi-loading-section');
    this.resultSection = this.popup.querySelector('#bazi-result-section');
    
    // 初始化地理位置相关元素
    this.birthplaceInput = this.popup.querySelector('#birthplace');
    this.autocompleteResults = this.popup.querySelector('#bazi-autocomplete-results');
    
    // 设置当前日期
    this.setDefaultDate();
  }
  
  // 设置默认日期为今天
  setDefaultDate() {
    const today = new Date().toISOString().split('T')[0];
    const birthdateInput = this.form.querySelector('#birthdate');
    if (birthdateInput) {
      birthdateInput.value = today;
    }
  }
  
  // 绑定事件
  bindEvents() {
    // 触发按钮
    const triggerBtn = document.getElementById('bazi-trigger-btn');
    if (triggerBtn) {
      triggerBtn.addEventListener('click', () => {
        this.show();
      });
    }
    
    // 关闭按钮
    const closeBtn = this.popup.querySelector('#bazi-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.hide();
      });
    }
    
    // 表单提交
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleFormSubmit();
      });
    }
    
    // 重新分析按钮
    const restartBtn = this.popup.querySelector('#bazi-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        this.restart();
      });
    }
    
    // 点击遮罩关闭
    const overlay = this.popup.querySelector('.bazi-popup-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.hide();
      });
    }
    
    // 出生地点输入事件
    if (this.birthplaceInput) {
      this.birthplaceInput.addEventListener('input', (e) => {
        this.handleBirthplaceInput(e.target.value);
      });
      
      // 键盘导航事件
      this.birthplaceInput.addEventListener('keydown', (e) => {
        this.autocompleteKeyboard(e);
      });
    }
    
    // 点击外部关闭自动完成结果
    document.addEventListener('click', (e) => {
      if (this.autocompleteResults && this.birthplaceInput && 
          !this.autocompleteResults.contains(e.target) && e.target !== this.birthplaceInput) {
        this.hideAutocompleteResults();
      }
    });
  }
  
  // 添加弹窗到页面
  addToPage() {
    if (!document.querySelector("#bazi-popup")) {
      document.body.appendChild(this.popup);
    }
    
    // 自动填充出生地点
    this.autoFillBirthplace();
  }
  
  // 显示弹窗
  show() {
    this.popup.style.display = 'flex';
    // 禁止背景滚动
    document.body.style.overflow = 'hidden';
  }
  
  // 自动填充出生地点 - 增强版全球地理位置支持
  autoFillBirthplace() {
    // 定义多个IP地理定位服务，提高可靠性
    const geoServices = [
      {
        name: 'ipinfo',
        url: 'https://ipinfo.io/json',
        parser: (data) => {
          if (data.city && data.region && data.country) {
            return {
              city: data.city,
              region: data.region,
              country: data.country,
              lat: parseFloat(data.loc.split(',')[0]),
              lon: parseFloat(data.loc.split(',')[1]),
              timezone: data.timezone
            };
          }
          throw new Error('IPInfo request failed');
        }
      },
      {
        name: 'freegeoip',
        url: 'https://freegeoip.app/json/',
        parser: (data) => {
          if (data.city && data.region_name && data.country_name) {
            return {
              city: data.city,
              region: data.region_name,
              country: data.country_name,
              lat: data.latitude,
              lon: data.longitude,
              timezone: data.time_zone
            };
          }
          throw new Error('FreeGeoIP request failed');
        }
      },
      {
        name: 'ipapi',
        url: 'https://ipapi.co/json/',
        parser: (data) => {
          if (data.city && data.region && data.country_name) {
            return {
              city: data.city,
              region: data.region,
              country: data.country_name,
              lat: data.latitude,
              lon: data.longitude,
              timezone: data.timezone
            };
          }
          throw new Error('IPAPI request failed');
        }
      }
    ];
    
    // 尝试获取地理位置信息
    const tryGeoService = (index = 0) => {
      if (index >= geoServices.length) {
        // 所有服务都失败了
        console.error('All IP geolocation services failed');
        // 设置默认值为北京
        if (this.birthplaceInput) {
          this.birthplaceInput.value = 'Beijing, Beijing, China';
        }
        return;
      }
      
      const service = geoServices[index];
      
      fetch(service.url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          const location = service.parser(data);
          // 格式化出生地点：城市, 省份/州, 国家
          const birthplace = `${location.city}, ${location.region}, ${location.country}`;
          if (this.birthplaceInput) {
            this.birthplaceInput.value = birthplace;
          }
          // 保存地理位置信息供后续使用
          this.geolocationData = location;
          console.log(`Successfully obtained geolocation using ${service.name}:`, location);
        })
        .catch(error => {
          console.error(`Failed to obtain geolocation using ${service.name}:`, error);
          // 尝试下一个服务
          tryGeoService(index + 1);
        });
    };
    
    // 开始尝试第一个服务
    tryGeoService();
  }
  
  // 处理出生地点输入 - 增强版全球城市支持
  async handleBirthplaceInput(value) {
    if (!value || value.length < 2) {
      this.hideAutocompleteResults();
      return;
    }
    
    // 使用Nominatim服务搜索城市
    const cities = await this.searchCities(value);
    
    // 转换为格式化的地点字符串
    const filteredLocations = cities.map(city => {
      const cityName = city.display_name || city.name;
      return cityName;
    }).slice(0, 20); // 限制显示20个结果
    
    // 显示自动完成结果
    this.showAutocompleteResults(filteredLocations, value);
  }
  
  // 显示自动完成结果
  showAutocompleteResults(locations, query) {
    if (!this.autocompleteResults) return;
    
    this.autocompleteResults.innerHTML = '';
    this.activeAutocompleteIndex = -1;
    
    if (locations.length === 0) {
      this.hideAutocompleteResults();
      return;
    }
    
    locations.forEach(location => {
      const item = document.createElement('div');
      item.className = 'bazi-autocomplete-item';
      
      // 高亮匹配部分
      const highlightedLocation = location.replace(new RegExp(`(${query})`, 'gi'), '<span class="highlight">$1</span>');
      item.innerHTML = highlightedLocation;
      
      // 点击选择
      item.addEventListener('click', () => {
        if (this.birthplaceInput) {
          this.birthplaceInput.value = location;
        }
        this.hideAutocompleteResults();
      });
      
      this.autocompleteResults.appendChild(item);
    });
    
    this.autocompleteResults.classList.add('active');
  }
  
  // 隐藏自动完成结果
  hideAutocompleteResults() {
    if (this.autocompleteResults) {
      this.autocompleteResults.classList.remove('active');
      this.autocompleteResults.innerHTML = '';
      this.activeAutocompleteIndex = -1;
    }
  }
  
  // 自动完成键盘导航
  autocompleteKeyboard(e) {
    if (!this.autocompleteResults || !this.autocompleteResults.classList.contains('active')) {
      return;
    }
    
    const items = this.autocompleteResults.querySelectorAll('.bazi-autocomplete-item');
    
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        this.activeAutocompleteIndex = (this.activeAutocompleteIndex + 1) % items.length;
        this.updateActiveAutocompleteItem(items);
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.activeAutocompleteIndex = (this.activeAutocompleteIndex - 1 + items.length) % items.length;
        this.updateActiveAutocompleteItem(items);
        break;
      case 'Enter':
        e.preventDefault();
        if (this.activeAutocompleteIndex >= 0 && items[this.activeAutocompleteIndex]) {
          items[this.activeAutocompleteIndex].click();
        }
        break;
      case 'Escape':
        this.hideAutocompleteResults();
        break;
    }
  }
  
  // 更新活动的自动完成项
  updateActiveAutocompleteItem(items) {
    items.forEach((item, index) => {
      if (index === this.activeAutocompleteIndex) {
        item.classList.add('active');
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        item.classList.remove('active');
      }
    });
  }
  
  // 隐藏弹窗
  hide() {
    this.popup.style.display = 'none';
    // 恢复背景滚动
    document.body.style.overflow = '';
  }
  
  // 重置表单
  resetForm() {
    this.form.reset();
    this.setDefaultDate();
    this.formSection.classList.remove('bazi-hidden');
    this.loadingSection.classList.add('bazi-hidden');
    this.resultSection.classList.add('bazi-hidden');
  }
  
  // 重启分析
  restart() {
    this.resetForm();
  }
  
  // 处理表单提交
  async handleFormSubmit() {
    // 显示加载状态
    this.formSection.classList.add('bazi-hidden');
    this.loadingSection.classList.remove('bazi-hidden');
    
    // 获取表单数据
    const formData = new FormData(this.form);
    const userData = {
      gender: formData.get('gender'),
      birthdate: formData.get('birthdate'),
      birthtime: parseInt(formData.get('birthtime')),
      birthplace: formData.get('birthplace'),
      relationship: formData.get('relationship')
    };
    
    // 只使用本地计算，无需选择计算方式
    this.aiConfig.useAI = false;
    
    try {
      // Generate Bazi analysis (async)
      const analysisResult = await this.generateBaziAnalysis(userData);
      
      // 显示结果
      this.displayResult(userData, analysisResult);
    } catch (error) {
      console.error('Failed to generate Bazi analysis:', error);
      // 显示错误信息
      this.showError('Failed to generate Bazi analysis, please try again later');
    }
  }
  
  // 显示错误信息
  showError(message) {
    this.loadingSection.classList.add('bazi-hidden');
    this.formSection.classList.remove('bazi-hidden');
    
    // 创建错误提示元素
    let errorElement = this.form.querySelector('#bazi-error');
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.id = 'bazi-error';
      errorElement.style.cssText = `
        color: #e53e3e;
        background-color: #fed7d7;
        padding: 12px;
        border-radius: 8px;
        margin-bottom: 15px;
        font-size: 14px;
        text-align: center;
      `;
      this.form.insertBefore(errorElement, this.form.firstChild);
    }
    
    errorElement.textContent = message;
    errorElement.style.display = 'block';
    
    // 3秒后自动隐藏错误提示
    setTimeout(() => {
      errorElement.style.display = 'none';
    }, 3000);
  }
  
  // Generate Bazi analysis
  async generateBaziAnalysis(userData) {
    // 输入验证
    const { isValid, errors } = this.validateInput(userData);
    if (!isValid) {
      throw new Error(`输入验证失败：${errors.join('; ')}`);
    }
    
    // 解析出生日期
    const birthDate = new Date(userData.birthdate);
    let year = birthDate.getFullYear();
    let month = birthDate.getMonth() + 1;
    let day = birthDate.getDate();
    let hour = userData.birthtime;
    
    // 处理时区和真太阳时
    const processedTime = this.processTime(userData.birthdate, hour);
    year = processedTime.year;
    month = processedTime.month;
    day = processedTime.day;
    hour = processedTime.hour;
    
    let bazi;
    
    // 优先使用本地计算八字
    console.log('使用本地计算八字...');
    bazi = this.calculateBazi(year, month, day, hour, processedTime.jieqi);
    console.log('本地计算结果:', bazi);
    
    // 基于八字年柱计算属相，确保属相计算的准确性
    const zodiac = this.calculateZodiac(year, month, day, bazi.year);
    
    // 计算五行
    const elements = this.calculateElements(bazi);
    
    // 计算五行喜忌
    const elementPreference = this.calculateElementPreference(elements);
    
    // 生成幸运颜色
    const luckyColors = this.generateLuckyColors(elementPreference);
    
    // 使用本地分析
    const analysis = this.analyzeBaziLocal(bazi, userData.gender, userData.relationship);
    
    return {
      zodiac,
      bazi,
      elements,
      elementPreference,
      luckyColors,
      // 分析内容
      structureAnalysis: analysis.structureAnalysis,
      comprehensiveAnalysis: analysis.comprehensiveAnalysis,
      personalityAnalysis: analysis.personalityAnalysis,
      careerAnalysis: analysis.careerAnalysis,
      wealthAnalysis: analysis.wealthAnalysis,
      loveAnalysis: analysis.loveAnalysis,
      healthAnalysis: analysis.healthAnalysis,
      currentYearAnalysis: analysis.currentYearAnalysis,
      recentLuckAnalysis: analysis.recentLuckAnalysis,
      noticePointsAnalysis: analysis.noticePointsAnalysis,
      resolutionAnalysis: analysis.resolutionAnalysis
    };
  }
  
  // Input validation
  validateInput(userData) {
    const errors = [];
    
    // Validate gender
    if (!userData.gender || !['male', 'female'].includes(userData.gender)) {
      errors.push('Please select a valid gender');
    }
    
    // Validate date of birth
    const birthdate = new Date(userData.birthdate);
    if (isNaN(birthdate.getTime())) {
      errors.push('Please select a valid date of birth');
    }
    
    // Validate time of birth
    if (isNaN(userData.birthtime) || userData.birthtime < 0 || userData.birthtime > 23) {
      errors.push('Please select a valid time of birth');
    }
    
    // Validate place of birth
    if (!userData.birthplace || userData.birthplace.trim() === '') {
      errors.push('Please enter place of birth');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }
  
  // 处理时间：时区转换和真太阳时计算
  processTime(birthdate, hour) {
    // 解析用户输入的日期和时间
    const userDate = new Date(birthdate);
    userDate.setHours(hour, 0, 0, 0);
    
    let year = userDate.getFullYear();
    let month = userDate.getMonth() + 1;
    let day = userDate.getDate();
    let processedHour = hour;
    
    // 处理时区和真太阳时
    if (this.geolocationData && this.geolocationData.timezone) {
      try {
        // 使用地理位置数据中的时区
        const timezone = this.geolocationData.timezone;
        console.log('使用地理位置时区:', timezone);

        // 将用户输入的本地时间转换为 UTC 时间
        const localDate = new Date(year, month - 1, day, hour, 0, 0);
        const utcTimestamp = localDate.getTime() - localDate.getTimezoneOffset() * 60000;

        // 使用 Intl.DateTimeFormat 进行时区转换
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: timezone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          hour12: false
        });

        const parts = formatter.formatToParts(new Date(utcTimestamp));
        const tzYear = parseInt(parts.find(p => p.type === 'year').value, 10);
        const tzMonth = parseInt(parts.find(p => p.type === 'month').value, 10);
        const tzDay = parseInt(parts.find(p => p.type === 'day').value, 10);
        let tzHour = parseInt(parts.find(p => p.type === 'hour').value, 10);

        // 处理真太阳时（简化版：仅根据经度粗略估算）
        if (this.geolocationData.lon !== undefined) {
          const longitude = this.geolocationData.lon;
          // 每 15° 经度差对应 1 小时，计算地方时与标准时的差值（分钟）
          const offsetMinutes = (longitude - 120) * 4;
          tzHour = (tzHour + Math.round(offsetMinutes / 60) + 24) % 24;
          console.log('应用真太阳时修正，经度:', longitude, '修正后小时:', tzHour);
        }

        // 更新返回结果
        year = tzYear;
        month = tzMonth;
        day = tzDay;
        hour = tzHour;

        console.log('时区转换结果:', { year, month, day, hour });
      } catch (error) {
        console.error('时区处理失败:', error);
      }
    }
    
    return {
      year: year,
      month: month,
      day: day,
      hour: processedHour,
      jieqi: this.calculateJieqi(year, month)
    };
  }
  
  // 计算节气
  calculateJieqi(year, month) {
    // 简化的节气计算，实际应用中需要更精确的算法
    return {
      '立春': new Date(year, 1, 4),
      '立夏': new Date(year, 4, 5),
      '立秋': new Date(year, 7, 7),
      '立冬': new Date(year, 10, 7)
    };
  }
  
  // 本地八字计算方法 - 使用lunar.js库获取准确的八字排盘
  calculateBazi(year, month, day, hour, jieqi) {
    try {
      // 使用lunar.js库计算八字
      console.log('使用lunar.js计算八字:', year, month, day, hour);
      
      // 创建阳历日期
      const solar = Solar.fromYmdHms(year, month, day, hour, 0, 0);
      // 转换为阴历
      const lunar = solar.getLunar();
      
      // 获取八字信息
      const baZi = lunar.getBaZi();
      
      console.log('lunar.js计算结果:', baZi);
      
      return {
        year: baZi[0],
        month: baZi[1],
        day: baZi[2],
        hour: baZi[3]
      };
    } catch (error) {
      console.error('使用lunar.js计算八字失败:', error);
      
      // 回退到传统算法
      console.log('回退到传统算法计算八字');
      
      // 天干地支表
      const tianGan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
      const diZhi = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
      
      // 1. 计算年柱
      const yearStart = 1900; // 1900年是庚子年
      const yearOffset = year - yearStart;
      const yearTGIndex = (yearOffset + 6) % 10; // 1900年是庚(6)
      const yearDZIndex = (yearOffset + 0) % 12; // 1900年是子(0)
      const yearBazi = tianGan[yearTGIndex] + diZhi[yearDZIndex];
      
      // 2. 计算月柱（简化处理，实际需要考虑节气）
      const monthMap = [
        [1, '寅'], [2, '卯'], [3, '辰'], [4, '巳'],
        [5, '午'], [6, '未'], [7, '申'], [8, '酉'],
        [9, '戌'], [10, '亥'], [11, '子'], [12, '丑']
      ];
      const monthDZ = monthMap[month - 1][1];
      // 月干计算：年干对应的五虎遁
      const wuHuDun = {
        '甲': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
        '乙': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
        '丙': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
        '丁': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'],
        '戊': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
        '己': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
        '庚': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
        '辛': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
        '壬': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
        '癸': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
      };
      const yearTG = yearBazi[0];
      const monthTG = wuHuDun[yearTG][month - 1];
      const monthBazi = monthTG + monthDZ;
      
      // 3. 计算日柱（简化处理）
      const date = new Date(year, month - 1, day);
      const baseDate = new Date('1900-01-01');
      const timeDiff = date.getTime() - baseDate.getTime();
      const dayOffset = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      
      const dayTGIndex = (dayOffset + 6) % 10; // 庚对应索引6
      const dayDZIndex = (dayOffset + 0) % 12; // 子对应索引0
      const dayBazi = tianGan[dayTGIndex] + diZhi[dayDZIndex];
      
      // 4. 计算时柱
      const hourMap = [
        [23, 1, '子'], [1, 3, '丑'], [3, 5, '寅'], [5, 7, '卯'],
        [7, 9, '辰'], [9, 11, '巳'], [11, 13, '午'], [13, 15, '未'],
        [15, 17, '申'], [17, 19, '酉'], [19, 21, '戌'], [21, 23, '亥']
      ];
      let hourDZ = '子';
      for (const [start, end, dz] of hourMap) {
        if (hour >= start && hour < end) {
          hourDZ = dz;
          break;
        }
      }
      // 时干计算：日干对应的五鼠遁
      const wuShuDun = {
        '甲': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
        '乙': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
        '丙': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
        '丁': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
        '戊': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'],
        '己': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
        '庚': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
        '辛': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
        '壬': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
        '癸': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
      };
      const dayTG = dayBazi[0];
      const hourIndex = Math.floor(hour / 2); // 每2小时一个时辰
      const hourTG = wuShuDun[dayTG][hourIndex];
      const hourBazi = hourTG + hourDZ;
      
      const result = {
        year: yearBazi,
        month: monthBazi,
        day: dayBazi,
        hour: hourBazi
      };
      
      console.log('传统算法计算结果:', result);
      return result;
    }
  }
  
  // 基于八字年柱计算属相 - 使用lunar.js库获取准确的属相信息
  calculateZodiac(year, month, day, yearBranch) {
    try {
      // 使用lunar.js库计算属相
      console.log('使用lunar.js计算属相:', year, month, day);
      
      // 创建阳历日期
      const solar = Solar.fromYmdHms(year, month, day, 12, 0, 0);
      // 转换为阴历
      const lunar = solar.getLunar();
      
      // 获取属相信息
      const shengxiao = lunar.getShengxiao();
      
      console.log('lunar.js计算属相结果:', shengxiao);
      
      // 中文生肖映射到英文
      const chineseToEnglishZodiac = {
        '鼠': 'Rat', '牛': 'cattle', '虎': 'Tiger', '兔': 'Rabbit',
        '龙': 'Dragon', '蛇': 'Snake', '马': 'Horse', '羊': 'Goat',
        '猴': 'Monkey', '鸡': 'Rooster', '狗': 'Dog', '猪': 'Pig'
      };
      
      return chineseToEnglishZodiac[shengxiao] || shengxiao;
    } catch (error) {
      console.error('使用lunar.js计算属相失败:', error);
      
      // 回退到传统算法
      console.log('回退到传统算法计算属相');
      
      const zodiacMap = {
        '子': 'Rat', '丑': 'cattle', '寅': 'Tiger', '卯': 'Rabbit',
        '辰': 'Dragon', '巳': 'Snake', '午': 'Horse', '未': 'Goat',
        '申': 'Monkey', '酉': 'Rooster', '戌': 'Dog', '亥': 'Pig'
      };
      
      // 提取年柱的地支
      const branch = yearBranch.charAt(1);
      return zodiacMap[branch] || 'Unknown';
    }
  }
  
  
  // Calculate Five Elements distribution
  calculateElements(bazi) {
    // Simplified Five Elements calculation based on Bazi heavenly stems and earthly branches
    const elementMap = {
      // Heavenly stems Five Elements
      '甲': 'Wood', '乙': 'Wood', '丙': 'Fire', '丁': 'Fire',
      '戊': 'Earth', '己': 'Earth', '庚': 'Metal', '辛': 'Metal',
      '壬': 'Water', '癸': 'Water',
      // Earthly branches Five Elements
      '子': 'Water', '丑': 'Earth', '寅': 'Wood', '卯': 'Wood',
      '辰': 'Earth', '巳': 'Fire', '午': 'Fire', '未': 'Earth',
      '申': 'Metal', '酉': 'Metal', '戌': 'Earth', '亥': 'Water'
    };
    
    // Calculate each Bazi's Five Elements
    const elements = {
      'Metal': 0,
      'Wood': 0,
      'Water': 0,
      'Fire': 0,
      'Earth': 0
    };
    
    // Traverse each heavenly stem and earthly branch of Bazi
    const baziValues = [bazi.year, bazi.month, bazi.day, bazi.hour];
    baziValues.forEach(value => {
      // Process heavenly stem
      const tianGan = value.charAt(0);
      if (elementMap[tianGan]) {
        elements[elementMap[tianGan]]++;
      }
      
      // Process earthly branch
      const diZhi = value.charAt(1);
      if (elementMap[diZhi]) {
        elements[elementMap[diZhi]]++;
      }
    });
    
    return elements;
  }
  
  // Calculate Five Elements preference
  calculateElementPreference(elements) {
    // Simplified Five Elements preference calculation, actual applications require more complex algorithms
    // Here we use a simple algorithm based on Five Elements balance
    const totalElements = Object.values(elements).reduce((sum, count) => sum + count, 0);
    const avgElements = totalElements / 5;
    
    // Likes: Elements that are weaker
    const likes = Object.entries(elements)
      .filter(([element, count]) => count < avgElements)
      .sort((a, b) => a[1] - b[1])
      .map(([element]) => element);
    
    // Dislikes: Elements that are stronger
    const dislikes = Object.entries(elements)
      .filter(([element, count]) => count > avgElements)
      .sort((a, b) => b[1] - a[1])
      .map(([element]) => element);
    
    return {
      likes,
      dislikes
    };
  }
  
  // Generate lucky colors
  generateLuckyColors(elementPreference) {
    // Simplified lucky color generation based on Five Elements preference
    const colorMap = {
      'Metal': ['White', 'Gold', 'Silver'],
      'Wood': ['Green', 'Cyan', 'Emerald'],
      'Water': ['Black', 'Blue', 'Dark Blue'],
      'Fire': ['Red', 'Purple', 'Pink'],
      'Earth': ['Yellow', 'Brown', 'Orange']
    };
    
    // Generate lucky colors from preferred elements
    const luckyColors = [];
    elementPreference.likes.forEach(element => {
      if (colorMap[element]) {
        luckyColors.push(...colorMap[element]);
      }
    });
    
    // Remove duplicates and return top 5 colors
    return [...new Set(luckyColors)].slice(0, 5);
  }
  
  // Local Bazi analysis method, as a backup for AI analysis
  analyzeBaziLocal(bazi, gender, relationship) {
    // Extract Five Elements attributes from Bazi
    const elements = this.calculateElements(bazi);
    const elementPreference = this.calculateElementPreference(elements);
    const luckyElements = elementPreference.likes;
    const unluckyElements = elementPreference.dislikes;
    
    // Extract day master heavenly stem
    const dayTG = bazi.day.charAt(0);
    
    // Generate analysis content
    const structureAnalysis = this.generateBaZiStructureAnalysis(bazi);
    const comprehensiveAnalysis = this.generateComprehensiveAnalysis(bazi);
    const personalityAnalysis = this.generatePersonalityAnalysis(elements, luckyElements, dayTG);
    const careerAnalysis = this.generateCareerAnalysis(elements, luckyElements, unluckyElements, dayTG);
    const wealthAnalysis = this.generateWealthAnalysis(elements, luckyElements, unluckyElements, dayTG);
    const loveAnalysis = this.generateLoveAnalysis(elements, luckyElements, unluckyElements, gender, relationship);
    const healthAnalysis = this.generateHealthAnalysis(elements, unluckyElements, dayTG);
    const currentYearAnalysis = this.generateCurrentYearAnalysis(elements, luckyElements, bazi);
    const recentLuckAnalysis = this.generateRecentLuckAnalysis(elements, luckyElements, bazi);
    const noticePointsAnalysis = this.generateNoticePointsAnalysis(elements, unluckyElements);
    const resolutionAnalysis = this.generateResolutionAnalysis(elements, luckyElements, unluckyElements);
    
    return {
      structureAnalysis: structureAnalysis,
      comprehensiveAnalysis: comprehensiveAnalysis,
      personalityAnalysis: personalityAnalysis,
      careerAnalysis: careerAnalysis,
      wealthAnalysis: wealthAnalysis,
      loveAnalysis: loveAnalysis,
      healthAnalysis: healthAnalysis,
      currentYearAnalysis: currentYearAnalysis,
      recentLuckAnalysis: recentLuckAnalysis,
      noticePointsAnalysis: noticePointsAnalysis,
      resolutionAnalysis: resolutionAnalysis
    };
  }
  
  // 生成性格分析
  generatePersonalityAnalysis(elements, luckyElements, dayTG) {
    // 简化的性格分析逻辑
    const analysis = [];
    
    analysis.push('1. Based on your Bazi, your personality traits are as follows：');
    
    // 基于日主天干的性格分析
    if (dayTG === '甲' || dayTG === '乙') {
      analysis.push('2. You have the traits of Wood, with an outgoing, enthusiastic personality, and you enjoy innovation and adventure.');
    } else if (dayTG === '丙' || dayTG === '丁') {
      analysis.push('2. You have the traits of Fire, with a lively, outgoing personality, and you enjoy communicating and sharing with others.');
    } else if (dayTG === '戊' || dayTG === '己') {
      analysis.push('2. You have the traits of Earth, with a steady, pragmatic personality, and you like to work in a down-to-earth manner.');
    } else if (dayTG === '庚' || dayTG === '辛') {
      analysis.push('2. You have the traits of Metal, with a strong, decisive personality, and you enjoy challenges and competition.');
    } else if (dayTG === '壬' || dayTG === '癸') {
      analysis.push('2. You have the traits of Water, with an intelligent, flexible personality, and you enjoy thinking and analyzing.');
    }
    
    // 基于五行分布的性格分析
    if (elements['Metal'] > 2) {
      analysis.push('3. You have strong sense of responsibility and organizational skills, suitable for management work.');
    }
    if (elements['Wood'] > 2) {
      analysis.push('3. You have strong creativity and imagination, suitable for art or design work.');
    }
    if (elements['Water'] > 2) {
      analysis.push('3. You have strong logical thinking ability, suitable for scientific or technical work.');
    }
    if (elements['Fire'] > 2) {
      analysis.push('3. You have strong expression and persuasion abilities, suitable for sales or public relations work.');
    }
    if (elements['Earth'] > 2) {
      analysis.push('3. You have strong patience and perseverance, suitable for work that requires long-term persistence.');
    }
    
    return analysis.join('\n');
  }
  
  // 生成事业运分析
  generateCareerAnalysis(elements, luckyElements, unluckyElements, dayTG) {
    // 简化的事业运分析逻辑
    const analysis = [];
    
    analysis.push('1. Based on your Bazi, your career fortune analysis is as follows：');
    
    // 基于日主天干的事业分析
    if (dayTG === '甲' || dayTG === '乙') {
      analysis.push('2. You are suitable for industries related to Wood, such as agriculture, forestry, education, culture, etc.');
    } else if (dayTG === '丙' || dayTG === '丁') {
      analysis.push('2. You are suitable for industries related to Fire, such as energy, electricity, electronics, communications, etc.');
    } else if (dayTG === '戊' || dayTG === '己') {
      analysis.push('2. You are suitable for industries related to Earth, such as real estate, construction, finance, insurance, etc.');
    } else if (dayTG === '庚' || dayTG === '辛') {
      analysis.push('2. You are suitable for industries related to Metal, such as finance, investment, metals, machinery, etc.');
    } else if (dayTG === '壬' || dayTG === '癸') {
      analysis.push('2. You are suitable for industries related to Water, such as water conservancy, transportation, tourism, logistics, etc.');
    }
    
    // 基于喜神的事业分析
    if (luckyElements.includes('金')) {
      analysis.push('3. You will have good development in finance, investment and other fields related to Metal.');
    }
    if (luckyElements.includes('木')) {
      analysis.push('3. You will have good development in education, culture and other fields related to Wood.');
    }
    if (luckyElements.includes('水')) {
      analysis.push('3. You will have good development in technology, communications and other fields related to Water.');
    }
    if (luckyElements.includes('火')) {
      analysis.push('3. You will have good development in sales, public relations and other fields related to Fire.');
    }
    if (luckyElements.includes('土')) {
      analysis.push('3. You will have good development in real estate, construction and other fields related to Earth.');
    }
    
    analysis.push('4. It is recommended that you pay more attention to your strengths in career development and fully utilize your expertise.');
    
    return analysis.join('\n');
  }
  
  // 生成财运分析
  generateWealthAnalysis(elements, luckyElements, unluckyElements, dayTG) {
    // 简化的财运分析逻辑
    const analysis = [];
    
    analysis.push('1. Based on your Bazi, your wealth fortune analysis is as follows：');
    
    // 基于日主天干的财运分析
    if (dayTG === '甲' || dayTG === '乙') {
      analysis.push('2. Your Day Master is Wood, and your wealth fortune is related to Water and Earth. Water nourishes Wood, while Earth restrains Wood, so you need to pay attention to wealth fluctuations.');
    } else if (dayTG === '丙' || dayTG === '丁') {
      analysis.push('2. Your Day Master is Fire, and your wealth fortune is related to Wood and Water. Wood nourishes Fire, while Water restrains Fire, so your wealth fortune is greatly affected by emotions.');
    } else if (dayTG === '戊' || dayTG === '己') {
      analysis.push('2. Your Day Master is Earth, and your wealth fortune is related to Fire and Wood. Fire nourishes Earth, while Wood restrains Earth, so your wealth fortune is relatively stable.');
    } else if (dayTG === '庚' || dayTG === '辛') {
      analysis.push('2. Your Day Master is Metal, and your wealth fortune is related to Earth and Fire. Earth nourishes Metal, while Fire restrains Metal, so your wealth fortune has significant fluctuations.');
    } else if (dayTG === '壬' || dayTG === '癸') {
      analysis.push('2. Your Day Master is Water, and your wealth fortune is related to Metal and Earth. Metal nourishes Water, while Earth restrains Water, so your wealth fortune is relatively stable.');
    }
    
    // 基于喜神的财运分析
    if (luckyElements.includes('金')) {
      analysis.push('3. You are suitable for increasing wealth through investment, financial management, etc., especially investments related to metals.');
    }
    if (luckyElements.includes('木')) {
      analysis.push('3. You are suitable for increasing wealth through entrepreneurship, innovation, etc., especially in wood-related industries.');
    }
    if (luckyElements.includes('水')) {
      analysis.push('3. You are suitable for increasing wealth through technology, knowledge, etc., especially in water-related industries.');
    }
    if (luckyElements.includes('火')) {
      analysis.push('3. You are suitable for increasing wealth through sales, promotion, etc., especially in fire-related industries.');
    }
    if (luckyElements.includes('土')) {
      analysis.push('3. You are suitable for increasing wealth through real estate, land, etc., especially in earth-related industries.');
    }
    
    analysis.push('4. It is recommended that you remain cautious in financial management and avoid excessive investment and risk-taking.');
    
    return analysis.join('\n');
  }
  
  // 生成感情运分析
  generateLoveAnalysis(elements, luckyElements, unluckyElements, gender, relationship) {
    // 简化的桃花运分析逻辑
    const analysis = [];
    
    // 基于性别的爱情分析
    if (gender === 'male') {
      analysis.push('1. As a male, your relationship fortune is related to wealth stars, and you need to pay attention to your communication style with the opposite sex.');
    } else {
      analysis.push('1. As a female, your relationship fortune is related to official stars, and you need to distinguish between sincerity and pretense.');
    }
    
    // 基于恋爱关系的分析
    switch (relationship) {
      case 'single':
        analysis.push('2. You are currently single and have many opportunities to meet new people.');
        break;
      case 'in-relationship':
        analysis.push('2. You are currently in a relationship, which is relatively stable, and you need to pay attention to maintenance and management.');
        break;
      case 'just-broke-up':
        analysis.push('2. You have just experienced the end of a relationship and need time to adjust and recover.');
        break;
      case 'engaged':
        analysis.push('2. You are engaged, your relationship is developing smoothly, and you are about to enter the marriage hall.');
        break;
      case 'married':
        analysis.push('2. You are married, your relationship tends to be stable, and you need to pay attention to maintaining freshness.');
        break;
      case 'looking-for-soulmate':
        analysis.push('2. You are looking for a soulmate and need to be patient for the right opportunity.');
        break;
      case 'complicated':
        analysis.push('2. Your current relationship situation is quite complicated and requires serious thought and handling.');
        break;
      default:
        analysis.push('2. Your relationship fortune is relatively stable, and you need to pay attention to seizing opportunities.');
    }
    
    // 基于喜神的感情分析
    if (luckyElements.includes('金')) {
      analysis.push('3. You are suitable for a partner with a strong, decisive personality, which helps to improve your relationship fortune.');
    }
    if (luckyElements.includes('木')) {
      analysis.push('3. You are suitable for a partner with an outgoing, lively personality, which helps to improve your relationship fortune.');
    }
    if (luckyElements.includes('水')) {
      analysis.push('3. You are suitable for a partner with an intelligent, flexible personality, which helps to improve your relationship fortune.');
    }
    if (luckyElements.includes('火')) {
      analysis.push('3. You are suitable for a partner with a passionate, outgoing personality, which helps to improve your relationship fortune.');
    }
    if (luckyElements.includes('土')) {
      analysis.push('3. You are suitable for a partner with a steady, pragmatic personality, which helps to improve your relationship fortune.');
    }
    
    analysis.push('4. It is recommended that you maintain sincerity and patience in your relationship and avoid excessive pursuit of perfection.');
    
    return analysis.join('\n');
  }
  
  // 生成健康运分析
  generateHealthAnalysis(elements, unluckyElements, dayTG) {
    // 简化的健康运分析逻辑
    const analysis = [];
    
    analysis.push('1. Based on your Bazi, your health fortune analysis is as follows：');
    
    // 基于日主天干的健康分析
    if (dayTG === '甲' || dayTG === '乙') {
      analysis.push('2. Your Day Master is Wood, and you need to pay special attention to liver and eye health.');
    } else if (dayTG === '丙' || dayTG === '丁') {
      analysis.push('2. Your Day Master is Fire, and you need to pay special attention to heart and circulatory system health.');
    } else if (dayTG === '戊' || dayTG === '己') {
      analysis.push('2. Your Day Master is Earth, and you need to pay special attention to spleen, stomach and digestive system health.');
    } else if (dayTG === '庚' || dayTG === '辛') {
      analysis.push('2. Your Day Master is Metal, and you need to pay special attention to respiratory system and lung health.');
    } else if (dayTG === '壬' || dayTG === '癸') {
      analysis.push('2. Your Day Master is Water, and you need to pay special attention to kidney and urinary system health.');
    }
    
    // 基于忌神的健康分析
    if (unluckyElements.includes('金')) {
      analysis.push('3. Be careful to avoid overwork and excessive stress, and protect your respiratory system and lung health.');
    }
    if (unluckyElements.includes('木')) {
      analysis.push('3. Pay attention to protecting liver and eye health, avoid staying up late and excessive eye use.');
    }
    if (unluckyElements.includes('水')) {
      analysis.push('3. Pay attention to protecting kidney and urinary system health, avoid excessive drinking and staying up late.');
    }
    if (unluckyElements.includes('火')) {
      analysis.push('3. Pay attention to protecting heart and circulatory system health, avoid overwork.');
    }
    if (unluckyElements.includes('土')) {
      analysis.push('3. Pay attention to protecting spleen and stomach health, avoid overeating and irregular diet.');
    }
    
    analysis.push('4. It is recommended that you maintain good living habits and have regular physical examinations.');
    
    return analysis.join('\n');
  }
  
  // 生成最近运势分析（包含流月运势）
  generateRecentLuckAnalysis(elements, luckyElements, bazi) {
    // 详细的最近运势分析逻辑
    const analysis = [];
    
    analysis.push('1. Based on your Bazi, your recent fortune analysis is as follows：');
    
    // 基于五行平衡的最近运势分析
    const totalElements = Object.values(elements).reduce((sum, count) => sum + count, 0);
    const avgElements = totalElements / 5;
    const isBalanced = Object.values(elements).every(count => Math.abs(count - avgElements) <= 1);
    
    if (isBalanced) {
      analysis.push('2. Your five elements are relatively balanced, and your recent fortune is stable, suitable for steady development.');
    } else {
      analysis.push('2. Recently, it is conducive to stable development and experience accumulation, preparing for long-term development.');
    }
    
    analysis.push('3. Recently, you need to pay attention to emotion management and avoid impulsive decisions.');
    analysis.push('4. It is recommended that you communicate more with family and friends to maintain good interpersonal relationships.');
    
    // 添加流月运势分析
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    
    analysis.push('\n5. Monthly Fortune Analysis：');
    
    // 分析当前月和接下来两个月的流月运势
    for (let i = 0; i < 3; i++) {
      const month = currentMonth + i;
      let analysisYear = currentYear;
      let analysisMonth = month;
      
      // 处理月份超过12的情况
      if (analysisMonth > 12) {
        analysisYear++;
        analysisMonth -= 12;
      }
      
      const liuYue = this.calculateLiuYue(analysisYear, analysisMonth);
      analysis.push(`\n6. ${analysisYear}/${analysisMonth} Monthly Analysis：`);
      analysis.push(`   - ${analysisYear}/${analysisMonth} is the ${liuYue.name} month.`);
      
      // 分析流月的五行属性
      const tgWuXing = this.getWuXingByTianGan(liuYue.tianGan);
      const dzWuXing = this.getWuXingByDiZhi(liuYue.diZhi);
      
      analysis.push(`   - Five Elements Attributes：Heavenly Stem ${tgWuXing}, Earthly Branch ${dzWuXing}`);
      
      // 流月运势分析
      analysis.push('   - Fortune Analysis：');
      
      if (tgWuXing === dzWuXing) {
        analysis.push('     * This month has pure Five Elements, fortune is relatively stable, suitable for steady development.');
      } else if (this.isSheng(tgWuXing, dzWuXing)) {
        analysis.push('     * This month Heavenly Stem nourishes Earthly Branch, fortune gradually rises, suitable for planning and preparation.');
      } else if (this.isKe(tgWuXing, dzWuXing)) {
        analysis.push('     * This month Heavenly Stem restrains Earthly Branch, need to overcome difficulties and work hard.');
      } else if (this.isSheng(dzWuXing, tgWuXing)) {
        analysis.push('     * This month Earthly Branch nourishes Heavenly Stem, fortune is good, suitable for active action.');
      } else if (this.isKe(dzWuXing, tgWuXing)) {
        analysis.push('     * This month Earthly Branch restrains Heavenly Stem, need to pay attention to adjustment and avoid excessive resistance.');
      }
      
      // 流月建议
      analysis.push('   - Monthly Suggestions：');
      analysis.push('     * Pay attention to rest and maintain a good mental state.');
      analysis.push('     * Arrange work and life reasonably to avoid overwork.');
      analysis.push('     * Pay attention to maintaining interpersonal relationships and avoid conflicts.');
      analysis.push('     * Seize the opportunities of this month and be proactive.');
    }
    
    return analysis.join('\n');
  }
  
  // 生成综合分析 - 专注于八字综合分析和五行调节方法
  generateComprehensiveAnalysis(bazi) {
    const elements = this.calculateElements(bazi);
    const elementStrength = this.analyzeElementStrength(elements);
    const analysis = [];
    
    analysis.push('1. Bazi Comprehensive Analysis：');
    
    // 综合描述五行过旺和过弱的情况
    if (elementStrength.excessive.length > 0 || elementStrength.deficient.length > 0) {
      let comprehensiveDescription = '   ';
      
      // 描述过旺元素
      if (elementStrength.excessive.length > 0) {
        comprehensiveDescription += `Your ${elementStrength.excessive.join(', ')} elements are excessive, `;
        elementStrength.excessive.forEach(element => {
          switch (element) {
            case 'Metal':
              comprehensiveDescription += 'which may cause respiratory problems, tense interpersonal relationships, ';
              break;
            case 'Wood':
              comprehensiveDescription += 'which may cause liver problems, mood swings, ';
              break;
            case 'Water':
              comprehensiveDescription += 'which may cause kidney problems, emotional depression, ';
              break;
            case 'Fire':
              comprehensiveDescription += 'which may cause heart problems, irritable personality, ';
              break;
            case 'Earth':
              comprehensiveDescription += 'which may cause spleen and stomach problems, rigid thinking, ';
              break;
          }
        });
        comprehensiveDescription += 'you need to pay attention to related health issues, ';
        
        elementStrength.excessive.forEach(element => {
          switch (element) {
            case 'Metal':
              comprehensiveDescription += 'can be adjusted by wearing wooden accessories, ';
              break;
            case 'Wood':
              comprehensiveDescription += 'can be adjusted by wearing metal accessories, ';
              break;
            case 'Water':
              comprehensiveDescription += 'can be adjusted by wearing red accessories, ';
              break;
            case 'Fire':
              comprehensiveDescription += 'can be adjusted by wearing black accessories, ';
              break;
            case 'Earth':
              comprehensiveDescription += 'can be adjusted by wearing green accessories, ';
              break;
          }
        });
      }
      
      // 描述过弱元素
      if (elementStrength.deficient.length > 0) {
        comprehensiveDescription += `Your ${elementStrength.deficient.join(', ')} elements are deficient, `;
        elementStrength.deficient.forEach(element => {
          switch (element) {
            case 'Metal':
              comprehensiveDescription += 'which may cause lack of decision-making ability, weak respiratory function, ';
              break;
            case 'Wood':
              comprehensiveDescription += 'which may cause lack of进取心, weak liver function, ';
              break;
            case 'Water':
              comprehensiveDescription += 'which may cause lack of flexibility, weak kidney function, ';
              break;
            case 'Fire':
              comprehensiveDescription += 'which may cause lack of enthusiasm, weak heart function, ';
              break;
            case 'Earth':
              comprehensiveDescription += 'which may cause lack of stability, weak spleen and stomach function, ';
              break;
          }
        });
        comprehensiveDescription += 'can be adjusted by ';
        elementStrength.deficient.forEach(element => {
          switch (element) {
            case 'Metal':
              comprehensiveDescription += 'wearing metal accessories, ';
              break;
            case 'Wood':
              comprehensiveDescription += 'wearing wooden accessories, ';
              break;
            case 'Water':
              comprehensiveDescription += 'wearing black accessories, ';
              break;
            case 'Fire':
              comprehensiveDescription += 'wearing red accessories, ';
              break;
            case 'Earth':
              comprehensiveDescription += 'wearing yellow accessories, ';
              break;
          }
        });
        comprehensiveDescription = comprehensiveDescription.replace(/, $/, '') + '.';
      }
      
      analysis.push(comprehensiveDescription);
    } else {
      analysis.push('   Your five elements are relatively balanced, and your overall fortune is stable, no special adjustment is needed.');
    }
    
    return analysis.join('\n');
  }

  // 生成需要注意和调节的地方 - 专注于警示信息
  generateNoticePointsAnalysis(elements, unluckyElements) {
    // 直接使用传递的elements参数，生成警示信息
    const elementStrength = this.analyzeElementStrength(elements);
    const analysis = [];
    
    analysis.push('1. ⚠️ Important Warning：The following are areas you need to pay special attention to and be vigilant about：');
    analysis.push('   These warning messages are based on your Bazi analysis and may have a significant impact on your health, career, wealth, and interpersonal relationships. Please attach great importance to them！');
    
    // 基于过旺元素的严重警示
    if (elementStrength.excessive.length > 0) {
      elementStrength.excessive.forEach(element => {
        analysis.push(`\n2. ⚠️ ${element} Element Excessive Warning：`);
        switch (element) {
          case 'Metal':
            analysis.push('   - Health Risk：Excessive Metal element may cause respiratory diseases, lung problems, skin allergies and other symptoms, and may lead to asthma, pneumonia and other diseases in severe cases.');
            analysis.push('   - Wealth Risk：May experience financial losses, investment failures, being deceived, especially in investments related to metals, finance and other fields.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have fierce conflicts, legal disputes with others, may lose money or get hurt due to verbal disputes.');
            analysis.push('   - Career Risk：People working in metal, machinery, finance and other industries may encounter major setbacks, and career development is hindered.');
            break;
          case 'Wood':
            analysis.push('   - Health Risk：Excessive Wood element may cause liver diseases, gallbladder problems, eye diseases and other symptoms, and may lead to hepatitis, cirrhosis and other diseases in severe cases.');
            analysis.push('   - Wealth Risk：May experience business failures, investment losses, cooperation breakdowns, especially in investments related to wood, agriculture and other fields.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have disputes, generate hatred with others, may hurt others or yourself due to impulsive behavior.');
            analysis.push('   - Career Risk：People working in wood, education, culture and other industries may encounter major setbacks, and career development is hindered.');
            break;
          case 'Water':
            analysis.push('   - Health Risk：Excessive Water element may cause kidney diseases, urinary system problems, reproductive system diseases and other symptoms, and may lead to nephritis, uremia and other diseases in severe cases.');
            analysis.push('   - Wealth Risk：May experience financial crises, debt burdens, investment failures, especially in investments related to water conservancy, transportation and other fields.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have cold wars, alienation with others, may hurt others or yourself due to excessive emotional fluctuations.');
            analysis.push('   - Career Risk：People working in water conservancy, transportation, tourism and other industries may encounter major setbacks, and career development is hindered.');
            break;
          case 'Fire':
            analysis.push('   - Health Risk：Excessive Fire element may cause heart diseases, high blood pressure, cerebrovascular diseases and other symptoms, and may lead to heart disease, cerebral hemorrhage and other diseases in severe cases.');
            analysis.push('   - Wealth Risk：May experience overheated investment, blind expansion, financial fraud and other situations, especially in investments related to energy, electronics and other fields.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have fierce quarrels, violent conflicts with others, may hurt others or yourself due to impatient behavior.');
            analysis.push('   - Career Risk：People working in energy, electronics, communications and other industries may encounter major setbacks, and career development is hindered.');
            break;
          case 'Earth':
            analysis.push('   - Health Risk：Excessive Earth element may cause spleen and stomach diseases, digestive system problems, obesity and other symptoms, and may lead to gastric cancer, intestinal cancer and other diseases in severe cases.');
            analysis.push('   - Wealth Risk：May experience investment traps, real estate losses, debt disputes and other situations, especially in investments related to real estate, construction and other fields.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have estrangement, misunderstanding with others, may lose friends and opportunities due to stubbornness.');
            analysis.push('   - Career Risk：People working in real estate, construction, finance and other industries may encounter major setbacks, and career development is hindered.');
            break;
        }
      });
    }
    
    // 基于过弱元素的严重警示
    if (elementStrength.deficient.length > 0) {
      elementStrength.deficient.forEach(element => {
        analysis.push(`\n3. ⚠️ ${element} Element Deficient Warning：`);
        switch (element) {
          case 'Metal':
            analysis.push('   - Health Risk：Deficient Metal element may cause weak respiratory function, easy to catch colds, coughs, and decreased resistance.');
            analysis.push('   - Wealth Risk：May experience poor fortune, low investment returns, lack of financial management ability and other situations.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to be indecisive, lack of主见, and be in a passive position in interpersonal relationships.');
            analysis.push('   - Career Risk：May lack competitiveness, decisiveness, slow career development, and difficult to obtain promotion opportunities.');
            break;
          case 'Wood':
            analysis.push('   - Health Risk：Deficient Wood element may cause weak liver function, easy to fatigue, feel low, and lack vitality.');
            analysis.push('   - Wealth Risk：May lack creativity, enterprising spirit, difficult to grasp investment opportunities, and have plain fortune.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to be introverted, lack confidence, and behave passively in social situations.');
            analysis.push('   - Career Risk：May lack innovation ability, pioneering spirit, career development is limited, and difficult to break through bottlenecks.');
            break;
          case 'Water':
            analysis.push('   - Health Risk：Deficient Water element may cause weak kidney function, easy to have edema, urinary system problems.');
            analysis.push('   - Wealth Risk：May lack flexibility, adaptability, difficult to adapt to market changes, and have unstable fortune.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have rigid thinking, lack communication skills, and have plain interpersonal relationships.');
            analysis.push('   - Career Risk：May lack wisdom, insight, difficult to grasp industry trends, and have slow career development.');
            break;
          case 'Fire':
            analysis.push('   - Health Risk：Deficient Fire element may cause weak heart function, easy to have palpitations, chest tightness and other symptoms.');
            analysis.push('   - Wealth Risk：May lack enthusiasm, motivation, difficult to actively seek opportunities, and have average fortune.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have a cold personality, lack affinity, and difficult to establish deep interpersonal relationships.');
            analysis.push('   - Career Risk：May lack leadership, influence, difficult to gain recognition from others, and career development is limited.');
            break;
          case 'Earth':
            analysis.push('   - Health Risk：Deficient Earth element may cause weak spleen and stomach function, easy to have indigestion, loss of appetite and other symptoms.');
            analysis.push('   - Wealth Risk：May lack stability, patience, difficult to accumulate wealth, and have fluctuating fortune.');
            analysis.push('   - Interpersonal Relationship Risk：Easy to have an impetuous personality, lack a sense of responsibility, and difficult to gain trust from others.');
            analysis.push('   - Career Risk：May lack perseverance, persistence, easy to give up halfway, and career development is difficult to last.');
            break;
        }
      });
    }
    
    // Comprehensive Risk Warning
    analysis.push('\n4. ⚠️ Comprehensive Risk Warning：');
    
    // Personalized Time Risk Analysis
    analysis.push('   - Time Risk：');
    if (unluckyElements.length > 0) {
      // Time risk analysis based on unlucky elements
      const monthRisks = {
        'Metal': 'Lunar July, August (Metal prosperous)',
        'Wood': 'Lunar January, February (Wood prosperous)',
        'Water': 'Lunar November, December (Water prosperous)',
        'Fire': 'Lunar April, May (Fire prosperous)',
        'Earth': 'Lunar March, June, September, December (Earth prosperous)'
      };
      
      const riskyMonths = [];
      unluckyElements.forEach(element => {
        if (monthRisks[element]) {
          riskyMonths.push(monthRisks[element]);
        }
      });
      
      if (riskyMonths.length > 0) {
        analysis.push(`     * Based on your unlucky element analysis, ${riskyMonths.join(', ')} are periods you need to be especially vigilant about, as these months may have a significant negative impact on your fortune.`);
        analysis.push('     * During these periods, it is recommended to keep a low profile, avoid major decisions, and strengthen self-protection.');
      } else {
        analysis.push('     * Although there are no clear time risks related to unlucky elements, you should still pay attention to the periods of solar term changes each year, such as around the Start of Spring, Start of Summer, Start of Autumn, and Start of Winter.');
      }
    } else {
      analysis.push('     * Although your overall fortune is relatively stable, you should still pay attention to important holidays and solar term change periods each year and remain vigilant.');
    }
    
    analysis.push('   - Location Risk：Avoid going to directions related to unlucky elements, such as avoiding the West for Metal unlucky element, avoiding the East for Wood unlucky element, etc.');
    analysis.push('   - Behavior Risk：Avoid participating in high-risk activities such as gambling, speculation, fighting, etc.');
    analysis.push('   - Crowd Risk：Avoid contact with people with extreme personalities or incompatible auras, especially those related to your unlucky elements.');
    
    // Emergency Response Measures
    analysis.push('\n5. 🚨 Emergency Response Measures：');
    analysis.push('   - Immediately adjust your living and working environment, remove items related to unlucky elements.');
    analysis.push('   - Wear accessories related to your lucky elements to enhance your personal energy field.');
    analysis.push('   - Conduct regular physical examinations, especially for organs related to unlucky elements.');
    analysis.push('   - Keep a low profile, avoid showing off, and reduce unnecessary social activities.');
    analysis.push('   - Do more good deeds, accumulate blessings, and enhance your positive energy.');
    
    return analysis.join('\n');
  }
  
  // 计算任意年份的天干地支
  calculateYearBazi(year) {
    // 天干地支表
    const tianGan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
    const diZhi = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
    
    // 1900年是庚子年
    const yearStart = 1900;
    const yearOffset = year - yearStart;
    const yearTGIndex = (yearOffset + 6) % 10; // 1900年是庚(6)
    const yearDZIndex = (yearOffset + 0) % 12; // 1900年是子(0)
    
    const yearTG = tianGan[yearTGIndex];
    const yearDZ = diZhi[yearDZIndex];
    
    // Calculate Five Elements attributes for the year
    const tianGanWuXing = {
      '甲': 'Wood', '乙': 'Wood',
      '丙': 'Fire', '丁': 'Fire',
      '戊': 'Earth', '己': 'Earth',
      '庚': 'Metal', '辛': 'Metal',
      '壬': 'Water', '癸': 'Water'
    };
    
    const diZhiWuXing = {
      '子': 'Water', '丑': 'Earth', '寅': 'Wood', '卯': 'Wood',
      '辰': 'Earth', '巳': 'Fire', '午': 'Fire', '未': 'Earth',
      '申': 'Metal', '酉': 'Metal', '戌': 'Earth', '亥': 'Water'
    };
    
    return {
      year: year,
      tianGan: yearTG,
      diZhi: yearDZ,
      wuXing: tianGanWuXing[yearTG],
      diZhiWuXing: diZhiWuXing[yearDZ]
    };
  }

  // Get Five Elements by Heavenly Stem
  getWuXingByTianGan(tianGan) {
    const map = {
      '甲': 'Wood', '乙': 'Wood',
      '丙': 'Fire', '丁': 'Fire',
      '戊': 'Earth', '己': 'Earth',
      '庚': 'Metal', '辛': 'Metal',
      '壬': 'Water', '癸': 'Water'
    };
    return map[tianGan] || '';
  }

  // Get Five Elements by Earthly Branch
  getWuXingByDiZhi(diZhi) {
    const map = {
      '子': 'Water', '丑': 'Earth', '寅': 'Wood', '卯': 'Wood',
      '辰': 'Earth', '巳': 'Fire', '午': 'Fire', '未': 'Earth',
      '申': 'Metal', '酉': 'Metal', '戌': 'Earth', '亥': 'Water'
    };
    return map[diZhi] || '';
  }

  // Analyze Five Elements relationship
  analyzeWuXingRelationship(element1, element2) {
    const wuXingShengKe = {
      'Wood': { 'Wood': 'Mutual assistance, supporting each other', 'Fire': 'Wood generates Fire, consuming itself', 'Earth': 'Wood restrains Earth, controlling the other', 'Metal': 'Metal restrains Wood, being controlled by the other', 'Water': 'Water generates Wood, receiving support' },
      'Fire': { 'Wood': 'Wood generates Fire, receiving support', 'Fire': 'Mutual assistance, supporting each other', 'Earth': 'Fire generates Earth, consuming itself', 'Metal': 'Fire restrains Metal, controlling the other', 'Water': 'Water restrains Fire, being controlled by the other' },
      'Earth': { 'Wood': 'Wood restrains Earth, being controlled by the other', 'Fire': 'Fire generates Earth, receiving support', 'Earth': 'Mutual assistance, supporting each other', 'Metal': 'Earth generates Metal, consuming itself', 'Water': 'Earth restrains Water, controlling the other' },
      'Metal': { 'Wood': 'Metal restrains Wood, controlling the other', 'Fire': 'Fire restrains Metal, being controlled by the other', 'Earth': 'Earth generates Metal, receiving support', 'Metal': 'Mutual assistance, supporting each other', 'Water': 'Metal generates Water, consuming itself' },
      'Water': { 'Wood': 'Water generates Wood, consuming itself', 'Fire': 'Water restrains Fire, controlling the other', 'Earth': 'Earth restrains Water, being controlled by the other', 'Metal': 'Metal generates Water, receiving support', 'Water': 'Mutual assistance, supporting each other' }
    };
    
    if (!wuXingShengKe[element1]) {
      return 'Unknown relationship';
    }
    return wuXingShengKe[element1][element2] || 'Unknown relationship';
  }

  // Calculate Ten Gods
  calculateShiShen(bazi) {
    // Heavenly stems order
    const tianGanOrder = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
    
    // Ten Gods correspondence
    const shiShenMap = {
      '甲': {
        '甲': 'Bi Jian', '乙': 'Jie Cai', '丙': 'Shi Shen', '丁': 'Shang Guan', '戊': 'Pian Cai',
        '己': 'Zheng Cai', '庚': 'Qi Sha', '辛': 'Zheng Guan', '壬': 'Pian Yin', '癸': 'Zheng Yin'
      },
      '乙': {
        '甲': 'Jie Cai', '乙': 'Bi Jian', '丙': 'Shang Guan', '丁': 'Shi Shen', '戊': 'Zheng Cai',
        '己': 'Pian Cai', '庚': 'Zheng Guan', '辛': 'Qi Sha', '壬': 'Zheng Yin', '癸': 'Pian Yin'
      },
      '丙': {
        '甲': 'Pian Yin', '乙': 'Zheng Yin', '丙': 'Bi Jian', '丁': 'Jie Cai', '戊': 'Shi Shen',
        '己': 'Shang Guan', '庚': 'Pian Cai', '辛': 'Zheng Cai', '壬': 'Qi Sha', '癸': 'Zheng Guan'
      },
      '丁': {
        '甲': 'Zheng Yin', '乙': 'Pian Yin', '丙': 'Jie Cai', '丁': 'Bi Jian', '戊': 'Shang Guan',
        '己': 'Shi Shen', '庚': 'Zheng Cai', '辛': 'Pian Cai', '壬': 'Zheng Guan', '癸': 'Qi Sha'
      },
      '戊': {
        '甲': 'Qi Sha', '乙': 'Zheng Guan', '丙': 'Pian Yin', '丁': 'Zheng Yin', '戊': 'Bi Jian',
        '己': 'Jie Cai', '庚': 'Shi Shen', '辛': 'Shang Guan', '壬': 'Pian Cai', '癸': 'Zheng Cai'
      },
      '己': {
        '甲': 'Zheng Guan', '乙': 'Qi Sha', '丙': 'Zheng Yin', '丁': 'Pian Yin', '戊': 'Jie Cai',
        '己': 'Bi Jian', '庚': 'Shang Guan', '辛': 'Shi Shen', '壬': 'Zheng Cai', '癸': 'Pian Cai'
      },
      '庚': {
        '甲': 'Pian Cai', '乙': 'Zheng Cai', '丙': 'Qi Sha', '丁': 'Zheng Guan', '戊': 'Pian Yin',
        '己': 'Zheng Yin', '庚': 'Bi Jian', '辛': 'Jie Cai', '壬': 'Shi Shen', '癸': 'Shang Guan'
      },
      '辛': {
        '甲': 'Zheng Cai', '乙': 'Pian Cai', '丙': 'Zheng Guan', '丁': 'Qi Sha', '戊': 'Zheng Yin',
        '己': 'Pian Yin', '庚': 'Jie Cai', '辛': 'Bi Jian', '壬': 'Shang Guan', '癸': 'Shi Shen'
      },
      '壬': {
        '甲': 'Shi Shen', '乙': 'Shang Guan', '丙': 'Pian Cai', '丁': 'Zheng Cai', '戊': 'Qi Sha',
        '己': 'Zheng Guan', '庚': 'Pian Yin', '辛': 'Zheng Yin', '壬': 'Bi Jian', '癸': 'Jie Cai'
      },
      '癸': {
        '甲': 'Shang Guan', '乙': 'Shi Shen', '丙': 'Zheng Cai', '丁': 'Pian Cai', '戊': 'Zheng Guan',
        '己': 'Qi Sha', '庚': 'Zheng Yin', '辛': 'Pian Yin', '壬': 'Jie Cai', '癸': 'Bi Jian'
      }
    };
    
    const dayTG = bazi.day.charAt(0);
    const shiShen = {};
    
    // Calculate Year Pillar God
    shiShen.year = shiShenMap[dayTG][bazi.year.charAt(0)] || 'Unknown';
    
    // Calculate Month Pillar God
    shiShen.month = shiShenMap[dayTG][bazi.month.charAt(0)] || 'Unknown';
    
    // Calculate Day Pillar God
    shiShen.day = shiShenMap[dayTG][bazi.day.charAt(0)] || 'Unknown';
    
    // Calculate Hour Pillar God
    shiShen.hour = shiShenMap[dayTG][bazi.hour.charAt(0)] || 'Unknown';
    
    return shiShen;
  }

  // 分析格局
  analyzeGeJu(bazi) {
    // 简化的格局分析逻辑
    const dayTG = bazi.day.charAt(0);
    const monthTG = bazi.month.charAt(0);
    const monthDZ = bazi.month.charAt(1);
    
    // 常见格局分析
    const geJuList = [];
    
    // Zheng Guan Pattern (Direct Officer)
    if (monthTG === '辛' && dayTG === '甲') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '庚' && dayTG === '乙') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '癸' && dayTG === '丙') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '壬' && dayTG === '丁') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '乙' && dayTG === '戊') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '甲' && dayTG === '己') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '丁' && dayTG === '庚') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '丙' && dayTG === '辛') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '己' && dayTG === '壬') {
      geJuList.push('Zheng Guan Pattern');
    } else if (monthTG === '戊' && dayTG === '癸') {
      geJuList.push('Zheng Guan Pattern');
    }
    
    // Qi Sha Pattern (7 Killings)
    if (monthTG === '庚' && dayTG === '甲') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '辛' && dayTG === '乙') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '壬' && dayTG === '丙') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '癸' && dayTG === '丁') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '甲' && dayTG === '戊') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '乙' && dayTG === '己') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '丙' && dayTG === '庚') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '丁' && dayTG === '辛') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '戊' && dayTG === '壬') {
      geJuList.push('Qi Sha Pattern');
    } else if (monthTG === '己' && dayTG === '癸') {
      geJuList.push('Qi Sha Pattern');
    }
    
    // Zheng Cai Pattern (Direct Wealth)
    if (monthTG === '己' && dayTG === '甲') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '戊' && dayTG === '乙') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '辛' && dayTG === '丙') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '庚' && dayTG === '丁') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '乙' && dayTG === '戊') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '甲' && dayTG === '己') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '丁' && dayTG === '庚') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '丙' && dayTG === '辛') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '己' && dayTG === '壬') {
      geJuList.push('Zheng Cai Pattern');
    } else if (monthTG === '戊' && dayTG === '癸') {
      geJuList.push('Zheng Cai Pattern');
    }
    
    // Pian Cai Pattern (Indirect Wealth)
    if (monthTG === '戊' && dayTG === '甲') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '己' && dayTG === '乙') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '庚' && dayTG === '丙') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '辛' && dayTG === '丁') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '甲' && dayTG === '戊') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '乙' && dayTG === '己') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '丙' && dayTG === '庚') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '丁' && dayTG === '辛') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '戊' && dayTG === '壬') {
      geJuList.push('Pian Cai Pattern');
    } else if (monthTG === '己' && dayTG === '癸') {
      geJuList.push('Pian Cai Pattern');
    }
    
    // Shi Shen Pattern (Food God)
    if (monthTG === '丙' && dayTG === '甲') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '丁' && dayTG === '乙') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '戊' && dayTG === '丙') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '己' && dayTG === '丁') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '庚' && dayTG === '戊') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '辛' && dayTG === '己') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '壬' && dayTG === '庚') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '癸' && dayTG === '辛') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '甲' && dayTG === '壬') {
      geJuList.push('Shi Shen Pattern');
    } else if (monthTG === '乙' && dayTG === '癸') {
      geJuList.push('Shi Shen Pattern');
    }
    
    // Shang Guan Pattern (Hurting Officer)
    if (monthTG === '丁' && dayTG === '甲') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '丙' && dayTG === '乙') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '己' && dayTG === '丙') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '戊' && dayTG === '丁') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '辛' && dayTG === '戊') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '庚' && dayTG === '己') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '癸' && dayTG === '庚') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '壬' && dayTG === '辛') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '乙' && dayTG === '壬') {
      geJuList.push('Shang Guan Pattern');
    } else if (monthTG === '甲' && dayTG === '癸') {
      geJuList.push('Shang Guan Pattern');
    }
    
    // Zheng Yin Pattern (Direct Seal)
    if (monthTG === '癸' && dayTG === '甲') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '壬' && dayTG === '乙') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '乙' && dayTG === '丙') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '甲' && dayTG === '丁') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '丁' && dayTG === '戊') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '丙' && dayTG === '己') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '己' && dayTG === '庚') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '戊' && dayTG === '辛') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '辛' && dayTG === '壬') {
      geJuList.push('Zheng Yin Pattern');
    } else if (monthTG === '庚' && dayTG === '癸') {
      geJuList.push('Zheng Yin Pattern');
    }
    
    // Pian Yin Pattern (Indirect Seal)
    if (monthTG === '壬' && dayTG === '甲') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '癸' && dayTG === '乙') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '甲' && dayTG === '丙') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '乙' && dayTG === '丁') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '丙' && dayTG === '戊') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '丁' && dayTG === '己') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '戊' && dayTG === '庚') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '己' && dayTG === '辛') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '庚' && dayTG === '壬') {
      geJuList.push('Pian Yin Pattern');
    } else if (monthTG === '辛' && dayTG === '癸') {
      geJuList.push('Pian Yin Pattern');
    }
    
    // Jian Lu Pattern (Built禄)
    if (monthDZ === '寅' && dayTG === '甲') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '卯' && dayTG === '乙') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '巳' && dayTG === '丙') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '午' && dayTG === '丁') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '辰' && dayTG === '戊') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '未' && dayTG === '己') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '申' && dayTG === '庚') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '酉' && dayTG === '辛') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '亥' && dayTG === '壬') {
      geJuList.push('Jian Lu Pattern');
    } else if (monthDZ === '子' && dayTG === '癸') {
      geJuList.push('Jian Lu Pattern');
    }
    
    // Yang Ren Pattern (Sheep Blade)
    if (monthDZ === '卯' && dayTG === '甲') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '寅' && dayTG === '乙') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '午' && dayTG === '丙') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '巳' && dayTG === '丁') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '未' && dayTG === '戊') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '辰' && dayTG === '己') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '酉' && dayTG === '庚') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '申' && dayTG === '辛') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '子' && dayTG === '壬') {
      geJuList.push('Yang Ren Pattern');
    } else if (monthDZ === '亥' && dayTG === '癸') {
      geJuList.push('Yang Ren Pattern');
    }
    
    return geJuList.length > 0 ? geJuList : ['Normal Pattern'];
  }

  // 分析五行强弱
  analyzeElementStrength(elements) {
    const totalElements = Object.values(elements).reduce((sum, count) => sum + count, 0);
    const avgElements = totalElements / 5;
    
    const excessiveElements = [];
    const deficientElements = [];
    
    Object.entries(elements).forEach(([element, count]) => {
      if (count > avgElements + 0.5) {
        excessiveElements.push(element);
      } else if (count < avgElements - 0.5) {
        deficientElements.push(element);
      }
    });
    
    return {
      excessive: excessiveElements,
      deficient: deficientElements,
      balanced: Object.entries(elements).filter(([element, count]) => 
        Math.abs(count - avgElements) <= 0.5
      ).map(([element]) => element)
    };
  }

  // 生成八字结构分析
  generateBaZiStructureAnalysis(bazi) {
    const analysis = [];
    
    analysis.push('1. Bazi Structure Analysis：');
    
    // 十神分析
    const shiShen = this.calculateShiShen(bazi);
    analysis.push('2. Ten Gods Analysis：');
    analysis.push(`   - Year Pillar God：${shiShen.year}`);
    analysis.push(`   - Month Pillar God：${shiShen.month}`);
    analysis.push(`   - Day Pillar God：${shiShen.day}`);
    analysis.push(`   - Hour Pillar God：${shiShen.hour}`);
    
    // Pattern analysis
    const geJuList = this.analyzeGeJu(bazi);
    analysis.push('3. Pattern Analysis：');
    analysis.push(`   - Your pattern：${geJuList.join('、')}`);
    
    // Pattern interpretation
    if (geJuList.includes('Zheng Guan Pattern')) {
      analysis.push('   - Zheng Guan Pattern：You have leadership abilities, suitable for stable careers such as management, civil service, etc.');
      analysis.push('   - Note：People with Zheng Guan pattern need to pay attention to their words and deeds, avoid being too rigidly upright.');
    } else if (geJuList.includes('Qi Sha Pattern')) {
      analysis.push('   - Qi Sha Pattern：You have decisiveness and competitiveness, suitable for challenging careers such as military, police, business, etc.');
      analysis.push('   - Note：People with Qi Sha pattern need to control their emotions, avoid being too impulsive and急躁.');
    } else if (geJuList.includes('Zheng Cai Pattern')) {
      analysis.push('   - Zheng Cai Pattern：You have financial management abilities, suitable for wealth-related careers such as finance, business, etc.');
      analysis.push('   - Note：People with Zheng Cai pattern need to be thrifty, avoid being too greedy for wealth.');
    } else if (geJuList.includes('Pian Cai Pattern')) {
      analysis.push('   - Pian Cai Pattern：You have speculative abilities, suitable for risky careers such as investment, entrepreneurship, etc.');
      analysis.push('   - Note：People with Pian Cai pattern need to control risks, avoid being too adventurous.');
    } else if (geJuList.includes('Shi Shen Pattern')) {
      analysis.push('   - Shi Shen Pattern：You have creativity, suitable for creative careers such as art, education, etc.');
      analysis.push('   - Note：People with Shi Shen pattern need to remain humble, avoid being too complacent.');
    } else if (geJuList.includes('Shang Guan Pattern')) {
      analysis.push('   - Shang Guan Pattern：You have expressive abilities, suitable for communication-related careers such as media, sales, etc.');
      analysis.push('   - Note：People with Shang Guan pattern need to be cautious in their words and deeds, avoid being too outspoken.');
    } else if (geJuList.includes('Zheng Yin Pattern')) {
      analysis.push('   - Zheng Yin Pattern：You have wisdom and compassion, suitable for service-related careers such as education, healthcare, etc.');
      analysis.push('   - Note：People with Zheng Yin pattern need to think independently, avoid being too dependent on others.');
    } else if (geJuList.includes('Pian Yin Pattern')) {
      analysis.push('   - Pian Yin Pattern：You have unique thinking patterns, suitable for innovation-related careers such as scientific research, technology, etc.');
      analysis.push('   - Note：People with Pian Yin pattern need to communicate with others, avoid being too solitary.');
    } else if (geJuList.includes('Jian Lu Pattern')) {
      analysis.push('   - Jian Lu Pattern：You have autonomous abilities, suitable for independent careers such as entrepreneurship, freelancing, etc.');
      analysis.push('   - Note：People with Jian Lu pattern need to cooperate with teams, avoid being too self-centered.');
    } else if (geJuList.includes('Yang Ren Pattern')) {
      analysis.push('   - Yang Ren Pattern：You have courage and decisiveness, suitable for challenging careers such as military, police, sports, etc.');
      analysis.push('   - Note：People with Yang Ren pattern need to control their temper, avoid being too impulsive and violent.');
    }
    
    return analysis.join('\n');
  }

  // 计算流年
  calculateLiuNian(year) {
    return this.calculateYearBazi(year);
  }

  // 计算流月
  calculateLiuYue(year, month) {
    // 简化的流月计算逻辑
    const diZhi = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
    const tianGan = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
    
    // 流月地支固定对应农历月份
    const liuYueDiZhi = diZhi[(month + 1) % 12];
    
    // 计算流月天干（基于年干）
    const yearBazi = this.calculateYearBazi(year);
    const wuHuDun = {
      '甲': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
      '乙': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
      '丙': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
      '丁': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'],
      '戊': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
      '己': ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙'],
      '庚': ['丙', '丁', '戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁'],
      '辛': ['戊', '己', '庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己'],
      '壬': ['庚', '辛', '壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛'],
      '癸': ['壬', '癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸']
    };
    
    const liuYueTianGan = wuHuDun[yearBazi.tianGan][month - 1];
    
    return {
      year: year,
      month: month,
      tianGan: liuYueTianGan,
      diZhi: liuYueDiZhi,
      name: liuYueTianGan + liuYueDiZhi
    };
  }

  // 生成流年分析
  generateLiuNianAnalysis(year, bazi) {
    const liuNian = this.calculateLiuNian(year);
    const analysis = [];
    
    analysis.push(`1. ${year} Year Liu Nian Analysis：`);
    analysis.push(`2. ${year} is the ${liuNian.tianGan}${liuNian.diZhi} year, Heavenly Stem belongs to ${liuNian.wuXing}, Earthly Branch belongs to ${liuNian.diZhiWuXing}.`);
    
    // 分析流年与八字的关系
    if (bazi) {
      const dayTG = bazi.day.charAt(0);
      const dayTGWuXing = this.getWuXingByTianGan(dayTG);
      analysis.push(`3. Your Day Master is ${dayTG}(${dayTGWuXing}), and the relationship with ${year} is analyzed as follows：`);
      
      // 基于天干五行生克关系
      const tianGanShengKe = this.analyzeWuXingRelationship(liuNian.wuXing, dayTGWuXing);
      analysis.push(`4. Heavenly Stem Relationship：The relationship between ${liuNian.wuXing} and ${dayTGWuXing} is ${tianGanShengKe}`);
      
      // 基于地支五行生克关系
      if (bazi.day.length > 1) {
        const dayDZ = bazi.day.charAt(1);
        const dayDZWuXing = this.getWuXingByDiZhi(dayDZ);
        const diZhiShengKe = this.analyzeWuXingRelationship(liuNian.diZhiWuXing, dayDZWuXing);
        analysis.push(`5. Earthly Branch Relationship：The relationship between ${liuNian.diZhiWuXing} and ${dayDZWuXing} is ${diZhiShengKe}`);
      }
    }
    
    // 流年运势建议
    analysis.push('\n6. Liu Nian Fortune Suggestions：');
    analysis.push('   - Pay attention to adjusting your mindset and adapting to the changes of the year.');
    analysis.push('   - Seize the opportunities of the year and be proactive.');
    analysis.push('   - Be vigilant about the risks and challenges that may come with the year.');
    analysis.push('   - Maintain good living habits and strengthen your physical health.');
    
    return analysis.join('\n');
  }

  // 生成流月分析
  generateLiuYueAnalysis(year, month) {
    const liuYue = this.calculateLiuYue(year, month);
    const analysis = [];
    
    analysis.push(`1. ${year}/${month} Liu Yue Analysis：`);
    analysis.push(`2. ${year}/${month} is the ${liuYue.name} month.`);
    
    // 分析流月的五行属性
    const tgWuXing = this.getWuXingByTianGan(liuYue.tianGan);
    const dzWuXing = this.getWuXingByDiZhi(liuYue.diZhi);
    
    analysis.push(`3. Five Elements Attributes：Heavenly Stem ${tgWuXing}, Earthly Branch ${dzWuXing}`);
    
    // 流月运势分析
    analysis.push('4. Liu Yue Fortune Analysis：');
    
    if (tgWuXing === dzWuXing) {
      analysis.push('   - This month has pure Five Elements, fortune is relatively stable, suitable for steady development.');
    } else if (this.isSheng(tgWuXing, dzWuXing)) {
      analysis.push('   - This month Heavenly Stem nourishes Earthly Branch, fortune gradually rises, suitable for planning and preparation.');
    } else if (this.isKe(tgWuXing, dzWuXing)) {
      analysis.push('   - This month Heavenly Stem restrains Earthly Branch, need to overcome difficulties and work hard.');
    } else if (this.isSheng(dzWuXing, tgWuXing)) {
      analysis.push('   - This month Earthly Branch nourishes Heavenly Stem, fortune is good, suitable for active action.');
    } else if (this.isKe(dzWuXing, tgWuXing)) {
      analysis.push('   - This month Earthly Branch restrains Heavenly Stem, need to pay attention to adjustment and avoid excessive resistance.');
    }
    
    // 流月建议
    analysis.push('5. Liu Yue Suggestions：');
    analysis.push('   - Pay attention to rest and maintain a good mental state.');
    analysis.push('   - Arrange work and life reasonably to avoid overwork.');
    analysis.push('   - Pay attention to maintaining interpersonal relationships and avoid conflicts.');
    analysis.push('   - Seize the opportunities of this month and be proactive.');
    
    return analysis.join('\n');
  }

  // 判断五行是否相生
  isSheng(element1, element2) {
    const shengMap = {
      'Metal': 'Water',
      'Water': 'Wood',
      'Wood': 'Fire',
      'Fire': 'Earth',
      'Earth': 'Metal'
    };
    return shengMap[element1] === element2;
  }

  // 判断五行是否相克
  isKe(element1, element2) {
    const keMap = {
      'Metal': 'Wood',
      'Wood': 'Earth',
      'Earth': 'Water',
      'Water': 'Fire',
      'Fire': 'Metal'
    };
    return keMap[element1] === element2;
  }

  // 生成今年运势分析（基于天干地支，包含流年分析）
  generateCurrentYearAnalysis(elements, luckyElements, bazi) {
    // 详细的今年运势分析逻辑
    const analysis = [];
    
    // 获取当前年份
    const currentYear = new Date().getFullYear();
    
    // 调用流年分析函数获取基础分析
    const liuNianAnalysis = this.generateLiuNianAnalysis(currentYear, bazi);
    analysis.push(liuNianAnalysis);
    
    // 添加基于喜神的今年运势分析
    const yearBazi = this.calculateYearBazi(currentYear);
    analysis.push('\n7. Lucky Element-Based Current Year Fortune Analysis：');
    
    if (luckyElements.includes(yearBazi.wuXing)) {
      analysis.push(`8. This year, ${yearBazi.wuXing} element is your lucky element, and your overall fortune is good.`);
      analysis.push(`9. Suitable for launching new plans and projects, especially in fields related to ${yearBazi.wuXing}.`);
      analysis.push(`10. Both wealth and career fortunes show good performance, and seizing opportunities can lead to significant progress.`);
    } else {
      // 分析喜神与今年五行的关系
      luckyElements.forEach(element => {
        const relationship = this.analyzeWuXingRelationship(element, yearBazi.wuXing);
        analysis.push(`8. Relationship between your lucky element ${element} and this year's ${yearBazi.wuXing}：${relationship}`);
      });
      
      analysis.push(`9. This year, you need to pay attention to adjusting your fortune and maintaining a positive mindset.`);
      analysis.push(`10. It is recommended to wear accessories related to your lucky element to help improve your fortune.`);
    }
    
    // Four Seasons Fortune Analysis (personalized based on Bazi and lucky elements)
    analysis.push(`11. ${currentYear} Four Seasons Fortune Deep Analysis：`);
    
    // Spring Fortune (Wood prosperous)
    analysis.push(`   - Spring (Wood prosperous)：`);
    if (luckyElements.includes('Wood')) {
      analysis.push(`     * Spring wood energy is abundant, highly compatible with your lucky element, making it the golden period for annual development with strong fortune.`);
      analysis.push(`     * Suitable for bold planning of new career directions, actively expanding network resources, and launching important projects.`);
      analysis.push(`     * Both wealth and career fortunes are on the rise; seizing opportunities can lead to significant breakthroughs.`);
      analysis.push(`     * Relationship fortune is also smooth; singles are likely to meet good partners, while those in relationships will experience deepening emotions.`);
    } else if (luckyElements.some(element => ['Metal', 'Earth'].includes(element))) {
      analysis.push(`     * Spring wood energy is abundant, forming certain constraints on your lucky element, resulting in relatively stable fortune.`);
      analysis.push(`     * It is recommended to maintain a low profile and stability, do a good job of foundation work, and reserve energy for the seasons when your lucky element prospers.`);
      analysis.push(`     * Pay attention to emotion management, avoid conflicts with others, and maintain good interpersonal relationships.`);
      analysis.push(`     * Be cautious with investments, avoid blind expansion, and focus on consolidating existing businesses.`);
    } else {
      analysis.push(`     * Spring wood energy germinates, overall fortune gradually rises, making it an important starting point for the whole year.`);
      analysis.push(`     * Suitable for formulating annual plans, clarifying development goals, and laying a solid foundation for the year's development.`);
      analysis.push(`     * Pay attention to work-life balance, maintain good work and rest habits, and enhance physical fitness.`);
      analysis.push(`     * Contact more elders and nobles to seek development opportunities and guidance.`);
    }
    
    // Summer Fortune (Fire prosperous)
    analysis.push(`   - Summer (Fire prosperous)：`);
    if (luckyElements.includes('Fire')) {
      analysis.push(`     * Summer fire energy is abundant, perfectly compatible with your lucky element, with fortune reaching the annual peak.`);
      analysis.push(`     * Career fortune is strong; suitable for actively expanding business, competing for important projects and cooperation opportunities.`);
      analysis.push(`     * Wealth fortune is prosperous, with significant investment returns and ideal windfall luck.`);
      analysis.push(`     * Social activities are frequent, network resources are effectively expanded, which is beneficial for long-term development.`);
    } else if (luckyElements.some(element => ['Water', 'Metal'].includes(element))) {
      analysis.push(`     * Summer fire energy is abundant, forming certain consumption on your lucky element, requiring fortune adjustment.`);
      analysis.push(`     * It is recommended to maintain calm and rationality, avoid impulsive decisions, and do a good job of emotion management.`);
      analysis.push(`     * Pay attention to heatstroke prevention and cooling, maintain good physical condition, and avoid overwork.`);
      analysis.push(`     * Be cautious with investments, avoid high-risk projects, and focus on stable investments.`);
    } else {
      analysis.push(`     * Summer fire energy is abundant, overall fortune is active, full of opportunities and challenges.`);
      analysis.push(`     * Suitable for active action, demonstrating personal abilities, and striving for career breakthroughs.`);
      analysis.push(`     * Pay attention to maintaining interpersonal relationships, avoid conflicts with others, and keep team harmony.`);
      analysis.push(`     * Balance work and life, avoid excessive consumption of physical strength and energy, and maintain sustainable development.`);
    }
    
    // Autumn Fortune (Metal prosperous)
    analysis.push(`   - Autumn (Metal prosperous)：`);
    if (luckyElements.includes('Metal')) {
      analysis.push(`     * Autumn metal energy is abundant, highly compatible with your lucky element, making it the golden season for harvest.`);
      analysis.push(`     * Career fortune rises steadily, previous efforts begin to show results, suitable for actively competing for performance.`);
      analysis.push(`     * Wealth fortune is prosperous, with stable positive income and ideal windfall luck, suitable for investment and financial management.`);
      analysis.push(`     * Relationship fortune is stable, suitable for stabilizing existing relationships; singles are likely to meet mature and stable partners.`);
    } else if (luckyElements.some(element => ['Fire', 'Wood'].includes(element))) {
      analysis.push(`     * Autumn metal energy is abundant, forming certain pressure on your lucky element, requiring fortune adjustment.`);
      analysis.push(`     * It is recommended to maintain an optimistic attitude, actively face challenges, and do a good job of work summary and planning.`);
      analysis.push(`     * Pay attention to physical health, especially respiratory and skin problems, and maintain good living habits.`);
      analysis.push(`     * Be cautious with investments, avoid blind following, and focus on fields you are familiar with.`);
    } else {
      analysis.push(`     * Autumn metal energy converges, overall fortune tends to be stable, making it the season for harvest and summary.`);
      analysis.push(`     * Suitable for summarizing the first half of the year's work results and formulating the second half's development plan.`);
      analysis.push(`     * Wealth fortune is relatively stable, suitable for rational investment and avoiding speculative behavior.`);
      analysis.push(`     * Relationship fortune is stable, suitable for deepening existing relationships and enhancing mutual understanding and trust.`);
    }
    
    // Winter Fortune (Water prosperous)
    analysis.push(`   - Winter (Water prosperous)：`);
    if (luckyElements.includes('Water')) {
      analysis.push(`     * Winter water energy is abundant, perfectly compatible with your lucky element, making it the golden period for rest and reserve.`);
      analysis.push(`     * Suitable for strengthening learning and self-improvement, reserving knowledge and skills for next year's development.`);
      analysis.push(`     * Wealth fortune is stable, suitable for steady investment and accumulating funds for next year's development.`);
      analysis.push(`     * Relationship fortune is warm, suitable for spending quality time with family and partners, enhancing emotional bonds.`);
    } else if (luckyElements.some(element => ['Earth', 'Fire'].includes(element))) {
      analysis.push(`     * Winter water energy is abundant, forming certain inhibition on your lucky element, requiring fortune adjustment.`);
      analysis.push(`     * It is recommended to maintain vitality, avoid excessive rest, and properly participate in social activities.`);
      analysis.push(`     * Pay attention to keeping warm and cold prevention, maintain good physical condition, and prevent respiratory diseases.`);
      analysis.push(`     * Be cautious with investments, avoid high-risk projects, and focus on stable investments.`);
    } else {
      analysis.push(`     * Winter water energy is hidden, overall fortune is relatively stable, making it an important period for rest and recuperation.`);
      analysis.push(`     * Suitable for reflecting on annual gains and losses, formulating next year's development plan, and preparing for the new year.`);
      analysis.push(`     * Pay attention to physical health, maintain good work and rest habits, and enhance physical fitness.`);
      analysis.push(`     * Reunite more with family, enjoy family happiness, and enhance family cohesion.`);
    }
    
    analysis.push(`\n12. It is recommended that you maintain good living habits this year, actively face challenges, and seize opportunities.`);
    
    return analysis.join('\n');
  }

  // 生成化解建议和开运方法
  generateResolutionAnalysis(elements, luckyElements, unluckyElements) {
    // 详细的化解建议分析逻辑
    const analysis = [];
    const elementStrength = this.analyzeElementStrength(elements);
    
    analysis.push('1. 🧧 Detailed Methods to Resolve Negative Factors and Enhance Fortune：');
    analysis.push('   The following methods have been verified by traditional Bazi analysis and have strong targeting and effectiveness. It is recommended to select and use them strictly according to personal circumstances.');
    
    // 基于喜用神的化解建议
    if (luckyElements.includes('金')) {
      analysis.push('\n2. 🌟 Metal Element Lucky Element Fortune Enhancement Method：');
      analysis.push('   - Jewelry Wearing：Preferred gold and silver accessories, followed by bracelets, rings, etc. The weight is preferably 3-9 grams, avoiding excessive weight.');
      analysis.push('   - Color Matching：Wear more white, gold, and silver clothing, use gold tableware and decorations.');
      analysis.push('   - Direction Selection：Sleeping bed and desk facing west, place metal ornaments in the west of office and home.');
      analysis.push('   - Item Placement：Place copper bells, metal vases, crystal balls, etc. in the west of the home, with 1, 4, or 6 items being appropriate.');
      analysis.push('   - Career Selection：Suitable for careers related to Metal, such as finance, metals, machinery, jewelry, etc.');
      analysis.push('   - Diet Regulation：Eat more white foods, such as rice, white radish, tremella, etc., which helps to enhance Metal energy.');
      analysis.push('   - Exercise Methods：Suitable for sports related to Metal, such as fencing, shooting, martial arts, etc.');
    }
    if (luckyElements.includes('木')) {
      analysis.push('\n2. 🌟 Wood Element Lucky Element Fortune Enhancement Method：');
      analysis.push('   - Jewelry Wearing：Preferred wooden accessories, such as peach wood, rosewood, Huanghuali, etc., avoid plastic materials.');
      analysis.push('   - Color Matching：Wear more green, cyan, and blue clothing, use decorations with wooden textures.');
      analysis.push('   - Direction Selection：Sleeping bed and desk facing east, place green plants in the east of office and home.');
      analysis.push('   - Item Placement：Place money trees, pothos, lucky bamboo, etc. in the east of the home, with 3 or 8 items being appropriate.');
      analysis.push('   - Career Selection：Suitable for careers related to Wood, such as education, culture, agriculture, forestry, etc.');
      analysis.push('   - Diet Regulation：Eat more green foods, such as vegetables, fruits, green tea, etc., which helps to enhance Wood energy.');
      analysis.push('   - Exercise Methods：Suitable for sports related to nature, such as yoga, tai chi, running, etc.');
    }
    if (luckyElements.includes('水')) {
      analysis.push('\n2. 🌟 Water Element Lucky Element Fortune Enhancement Method：');
      analysis.push('   - Jewelry Wearing：Preferred crystal, obsidian, sapphire, etc., avoid red accessories.');
      analysis.push('   - Color Matching：Wear more black, blue, and gray clothing, use decorations with flowing water patterns.');
      analysis.push('   - Direction Selection：Sleeping bed and desk facing north, place water features in the north of office and home.');
      analysis.push('   - Item Placement：Place fish tanks, water features, feng shui wheels, etc. in the north of the home, with 1 or 6 items being appropriate.');
      analysis.push('   - Career Selection：Suitable for careers related to Water, such as water conservancy, transportation, tourism, logistics, etc.');
      analysis.push('   - Diet Regulation：Eat more black foods, such as black rice, black beans, black sesame, etc., which helps to enhance Water energy.');
      analysis.push('   - Exercise Methods：Suitable for sports related to Water, such as swimming, diving, skating, etc.');
    }
    if (luckyElements.includes('火')) {
      analysis.push('\n2. 🌟 Fire Element Lucky Element Fortune Enhancement Method：');
      analysis.push('   - Jewelry Wearing：Preferred red agate, ruby, red coral, etc., avoid black accessories.');
      analysis.push('   - Color Matching：Wear more red, orange, and purple clothing, use decorations with flame patterns.');
      analysis.push('   - Direction Selection：Sleeping bed and desk facing south, place red items in the south of office and home.');
      analysis.push('   - Item Placement：Place red lanterns, red Chinese knots, candles, etc. in the south of the home, with 2 or 7 items being appropriate.');
      analysis.push('   - Career Selection：Suitable for careers related to Fire, such as energy, electricity, electronics, communications, etc.');
      analysis.push('   - Diet Regulation：Eat more red foods, such as chili, tomatoes, red dates, etc., which helps to enhance Fire energy.');
      analysis.push('   - Exercise Methods：Suitable for sports related to vitality, such as football, basketball, dancing, etc.');
    }
    if (luckyElements.includes('土')) {
      analysis.push('\n2. 🌟 Earth Element Lucky Element Fortune Enhancement Method：');
      analysis.push('   - Jewelry Wearing：Preferred yellow jade, yellow crystal, amber, etc., avoid green accessories.');
      analysis.push('   - Color Matching：Wear more yellow, brown, and earthy yellow clothing, use decorations with earth patterns.');
      analysis.push('   - Direction Selection：Sleeping bed and desk facing center or southwest, northeast, place ceramic items in the center of office and home.');
      analysis.push('   - Item Placement：Place ceramic vases, jade items, yellow crystals, etc. in the center of the home, with 5 or 10 items being appropriate.');
      analysis.push('   - Career Selection：Suitable for careers related to Earth, such as real estate, construction, finance, insurance, etc.');
      analysis.push('   - Diet Regulation：Eat more yellow foods, such as corn, pumpkin, bananas, etc., which helps to enhance Earth energy.');
      analysis.push('   - Exercise Methods：Suitable for sports related to strength, such as weightlifting, wrestling, martial arts, etc.');
    }
    
    // 基于五行过弱的调节方法
    if (elementStrength.deficient.length > 0) {
      analysis.push('\n3. ⚖️ Five Elements Deficiency Regulation Methods：');
      elementStrength.deficient.forEach(element => {
        switch (element) {
          case '金':
            analysis.push('   - Metal Element Deficiency Regulation：');
            analysis.push('     * Jewelry Wearing：Wear gold, silver, crystal and other metal accessories to enhance Metal energy.');
            analysis.push('     * Color Matching：Wear more white, gold, and silver clothing, use gold decorations.');
            analysis.push('     * Direction Selection：Sleeping bed and desk facing west, place metal items in the west of the home.');
            analysis.push('     * Diet Regulation：Eat more white foods, such as rice, white radish, tremella, etc., to enhance Metal energy.');
            analysis.push('     * Career Selection：Suitable for careers related to Metal, such as finance, metals, machinery, etc.');
            break;
          case '木':
            analysis.push('   - Wood Element Deficiency Regulation：');
            analysis.push('     * Jewelry Wearing：Wear wooden accessories, such as peach wood, rosewood, Huanghuali, etc., to enhance Wood energy.');
            analysis.push('     * Color Matching：Wear more green, cyan, and blue clothing, use decorations with wooden textures.');
            analysis.push('     * Direction Selection：Sleeping bed and desk facing east, place green plants in the east of the home.');
            analysis.push('     * Diet Regulation：Eat more green foods, such as vegetables, fruits, green tea, etc., to enhance Wood energy.');
            analysis.push('     * Career Selection：Suitable for careers related to Wood, such as education, culture, agriculture, etc.');
            break;
          case '水':
            analysis.push('   - Water Element Deficiency Regulation：');
            analysis.push('     * Jewelry Wearing：Wear crystal, obsidian, sapphire, etc., to enhance Water energy.');
            analysis.push('     * Color Matching：Wear more black, blue, and gray clothing, use decorations with flowing water patterns.');
            analysis.push('     * Direction Selection：Sleeping bed and desk facing north, place water features in the north of the home.');
            analysis.push('     * Diet Regulation：Eat more black foods, such as black rice, black beans, black sesame, etc., to enhance Water energy.');
            analysis.push('     * Career Selection：Suitable for careers related to Water, such as water conservancy, transportation, tourism, etc.');
            break;
          case '火':
            analysis.push('   - Fire Element Deficiency Regulation：');
            analysis.push('     * Jewelry Wearing：Wear red agate, ruby, red coral, etc., to enhance Fire energy.');
            analysis.push('     * Color Matching：Wear more red, orange, and purple clothing, use decorations with flame patterns.');
            analysis.push('     * Direction Selection：Sleeping bed and desk facing south, place red items in the south of the home.');
            analysis.push('     * Diet Regulation：Eat more red foods, such as chili, tomatoes, red dates, etc., to enhance Fire energy.');
            analysis.push('     * Career Selection：Suitable for careers related to Fire, such as energy, electricity, electronics, etc.');
            break;
          case '土':
            analysis.push('   - Earth Element Deficiency Regulation：');
            analysis.push('     * Jewelry Wearing：Wear yellow jade, yellow crystal, amber, etc., to enhance Earth energy.');
            analysis.push('     * Color Matching：Wear more yellow, brown, and earthy yellow clothing, use decorations with earth patterns.');
            analysis.push('     * Direction Selection：Sleeping bed and desk facing center or southwest, northeast, place ceramic items in the center of the home.');
            analysis.push('     * Diet Regulation：Eat more yellow foods, such as corn, pumpkin, bananas, etc., to enhance Earth energy.');
            analysis.push('     * Career Selection：Suitable for careers related to Earth, such as real estate, construction, finance, etc.');
            break;
        }
      });
    }
    
    // 基于忌神的化解建议
    analysis.push('\n4. 🛡️ Special Methods to Resolve Unlucky Elements：');
    if (unluckyElements.includes('金')) {
      analysis.push('   - Metal Unlucky Element Resolution：Wear wooden accessories, use green items, avoid western direction, eat more green foods.');
    }
    if (unluckyElements.includes('木')) {
      analysis.push('   - Wood Unlucky Element Resolution：Wear metal accessories, use white items, avoid eastern direction, eat more white foods.');
    }
    if (unluckyElements.includes('水')) {
      analysis.push('   - Water Unlucky Element Resolution：Wear red accessories, use red items, avoid northern direction, eat more red foods.');
    }
    if (unluckyElements.includes('火')) {
      analysis.push('   - Fire Unlucky Element Resolution：Wear black accessories, use black items, avoid southern direction, eat more black foods.');
    }
    if (unluckyElements.includes('土')) {
      analysis.push('   - Earth Unlucky Element Resolution：Wear green accessories, use green items, avoid central direction, eat more green foods.');
    }
    
    // 综合开运方法
    analysis.push('\n5. 🎯 Comprehensive Fortune Enhancement Methods：');
    analysis.push('   - Feng Shui Adjustment：Regularly adjust home and office environments, conduct a thorough cleaning every quarter.');
    analysis.push('   - Energy Field Enhancement：Take 10 minutes of deep breathing towards the lucky element direction every morning, which helps to absorb positive energy.');
    analysis.push('   - Merit Accumulation：Do at least 3 good deeds every month, such as donating, volunteering, helping others, etc.');
    analysis.push('   - Mindset Adjustment：Meditate for 15 minutes every day, maintain inner peace, and avoid negative emotions.');
    analysis.push('   - Clothing Selection：Adjust clothing colors and styles timely according to seasonal and fortune changes.');
    analysis.push('   - Social Optimization：Contact more people with compatible energy fields, avoid deep interactions with people with incompatible energy fields.');
    analysis.push('   - Learning Enhancement：Regularly learn traditional culture, Bazi knowledge, and enhance self-cultivation.');
    
    // 紧急开运法
    analysis.push('\n6. ⚡ Emergency Fortune Enhancement Method (Suitable for When Fortune Declines Sharply)：');
    analysis.push('   - Immediately wear accessories related to lucky elements, preferably those that have been consecrated.');
    analysis.push('   - Light candles of the corresponding lucky element color in home or office for 7 consecutive days.');
    analysis.push('   - Go to temples, Taoist temples and other religious places to pray sincerely.');
    analysis.push('   - Conduct a thorough home cleaning, remove all items related to unlucky elements.');
    analysis.push('   - Donate part of your property to people in need to accumulate merit.');
    analysis.push('   - Adjust work and rest time, ensure sufficient sleep, avoid staying up late.');
    analysis.push('   - Temporarily reduce social activities, keep a low profile, avoid showing off.');
    
    // 长期开运规划
    analysis.push('\n7. 📅 Long-term Fortune Enhancement Plan：');
    analysis.push('   - Every Spring：Conduct a comprehensive feng shui adjustment, clean up old items, and add new items.');
    analysis.push('   - Every First Day of the Month：Wear new accessories related to lucky elements, replace feng shui items.');
    analysis.push('   - Every Morning：Pray towards the lucky element direction and set daily goals.');
    analysis.push('   - Every Week：Engage in sports related to lucky elements to enhance physical fitness and energy field.');
    analysis.push('   - Every Quarter：Have regular physical examinations to timely detect and adjust health problems.');
    analysis.push('   - Every Year：Review the year\'s fortune and adjust the next year\'s fortune enhancement strategy.');
    
    return analysis.join('\n');
  }
  
  // 异步显示结果
  async displayResult(userData, analysisResult) {
    // 辅助函数：安全设置元素文本内容
    const safeSetText = (id, text) => {
      const element = document.getElementById(id);
      if (element) {
        element.textContent = text;
      }
    };
    
    // 辅助函数：安全设置元素HTML内容（用于包含换行的分析文本）
    const safeSetHTML = (id, html) => {
      const element = document.getElementById(id);
      if (element) {
        element.innerHTML = html;
      }
    };
    
    // 更新基本信息
    safeSetText('result-gender', userData.gender === 'male' ? 'Male' : 'Female');
    safeSetText('result-birthdate', userData.birthdate);
    safeSetText('result-birthtime', `${userData.birthtime}:00`);
    safeSetText('result-birthplace', userData.birthplace);
    
    // 关系状态英文映射
    const relationshipMap = {
      'single': 'Single',
      'in-relationship': 'In a Relationship',
      'just-broke-up': 'Just Broke Up',
      'engaged': 'Engaged',
      'married': 'Married',
      'looking-for-soulmate': 'Looking for Soulmate',
      'complicated': 'It\'s Complicated'
    };
    safeSetText('result-relationship', relationshipMap[userData.relationship] || userData.relationship);
    
    // 更新命理分析
    safeSetText('result-zodiac', analysisResult.zodiac);
    safeSetText('result-bazi', `${analysisResult.bazi.year} ${analysisResult.bazi.month} ${analysisResult.bazi.day} ${analysisResult.bazi.hour}`);
    
    // 格式化五行分布
    const elementsText = Object.entries(analysisResult.elements)
      .map(([element, count]) => `${element}: ${count}`)
      .join(' | ');
    safeSetText('result-elements', elementsText);
    
    // 五行喜忌
    safeSetText('result-element-preference', 
      `Likes: ${analysisResult.elementPreference.likes.join(', ')} | Dislikes: ${analysisResult.elementPreference.dislikes.join(', ')}`);
    
    // 幸运颜色
    safeSetText('result-lucky-colors', analysisResult.luckyColors.join(', '));
    
    // 更新详细分析内容
    if (analysisResult.structureAnalysis) {
      safeSetHTML('result-structure-analysis', analysisResult.structureAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.comprehensiveAnalysis) {
      safeSetHTML('result-comprehensive-analysis', analysisResult.comprehensiveAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.personalityAnalysis) {
      safeSetHTML('result-personality-analysis', analysisResult.personalityAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.careerAnalysis) {
      safeSetHTML('result-career-analysis', analysisResult.careerAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.wealthAnalysis) {
      safeSetHTML('result-wealth-analysis', analysisResult.wealthAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.loveAnalysis) {
      safeSetHTML('result-love-analysis', analysisResult.loveAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.healthAnalysis) {
      safeSetHTML('result-health-analysis', analysisResult.healthAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.currentYearAnalysis) {
      safeSetHTML('result-current-year-analysis', analysisResult.currentYearAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.recentLuckAnalysis) {
      safeSetHTML('result-recent-luck-analysis', analysisResult.recentLuckAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.noticePointsAnalysis) {
      safeSetHTML('result-notice-points-analysis', analysisResult.noticePointsAnalysis.replace(/\n/g, '<p>'));
    }
    if (analysisResult.resolutionAnalysis) {
      safeSetHTML('result-resolution-analysis', analysisResult.resolutionAnalysis.replace(/\n/g, '<p>'));
    }
    
    // 显示结果部分
    if (this.loadingSection) {
      this.loadingSection.classList.add('bazi-hidden');
    }
    if (this.resultSection) {
      this.resultSection.classList.remove('bazi-hidden');
    }
    
    // 异步生成产品推荐
    await this.generateProductRecommendations(analysisResult, userData);
  }

  // 生成产品推荐
  async generateProductRecommendations(analysisResult, userData) {
    try {
      console.log('Starting product recommendation generation...');
      
      // 获取产品数据
      const products = await this.getProducts();
      console.log('Retrieved product data:', products.length, 'products');
      
      if (products.length === 0) {
        console.log('No product data, skipping recommendations');
        return;
      }
      
      // 匹配产品
      const recommendedProducts = this.matchProductsByBaziFactors(products, analysisResult, userData);
      console.log('Matched recommended products:', recommendedProducts.length, 'products');
      
      // 插入推荐产品到分析结果中
      await this.insertRecommendationsIntoAnalysis(recommendedProducts, analysisResult);
      
      console.log('Product recommendation generation completed');
    } catch (error) {
      console.error('Failed to generate product recommendations:', error);
    }
  }

  // 获取产品数据的方法 - 从JSON数据中获取（Shopify Liquid注入）
  async getProductsFromJSON() {
    try {
      const productsDataElement = document.getElementById('bazi-products-data');
      if (productsDataElement) {
        const productsData = JSON.parse(productsDataElement.textContent);
        console.log('从JSON数据获取到的产品:', productsData);
        return productsData;
      }
      return [];
    } catch (error) {
      console.error('从JSON获取产品数据失败:', error);
      return [];
    }
  }

  // 获取产品数据的方法 - 从DOM中获取（备选方案）
  async getProductsFromDOM() {
    try {
      const productElements = document.querySelectorAll('.product-item');
      const products = Array.from(productElements).map(el => {
        return {
          id: el.getAttribute('data-product-id'),
          title: el.querySelector('.product-title')?.textContent || '',
          price: el.querySelector('.product-price')?.textContent || '',
          image: el.querySelector('img')?.src || '',
          url: el.querySelector('a')?.href || '',
          tags: el.getAttribute('data-tags')?.split(',') || [],
          metafields: {
            bazi_element: el.getAttribute('data-meta-element'),
            bazi_effect: el.getAttribute('data-meta-effect') ? [el.getAttribute('data-meta-effect')] : [],
            bazi_lucky_color: el.getAttribute('data-meta-color') ? el.getAttribute('data-meta-color').split(',') : [],
            bazi_wealth_luck: el.getAttribute('data-meta-wealth-luck') === 'true',
            bazi_career_luck: el.getAttribute('data-meta-career-luck') === 'true',
            bazi_love_luck: el.getAttribute('data-meta-love-luck') === 'true',
            bazi_health_luck: el.getAttribute('data-meta-health-luck') === 'true',
            bazi_current_year_luck: el.getAttribute('data-meta-current-year-luck') === 'true'
          }
        };
      });
      return products;
    } catch (error) {
      console.error('从DOM获取产品数据失败:', error);
      return [];
    }
  }

  // 获取产品数据的主方法 - 支持多种数据源
  async getProducts() {
    // 优先从JSON数据获取（Shopify Liquid注入）
    let products = await this.getProductsFromJSON();
    
    // 如果JSON数据为空，尝试从DOM获取
    if (products.length === 0) {
      products = await this.getProductsFromDOM();
    }
    
    // 如果仍然为空，返回测试产品
    if (products.length === 0) {
      // products = this.getTestProducts();
      products = [];
    }
    
    return products;
  }

  // Get test product data (as fallback)
  getTestProducts() {
    console.warn('Using test product data: In production environment, it is recommended to inject real product data through Shopify Liquid');
    return [
      {
        id: 'test-1',
        title: 'Gold Lucky Bracelet',
        price: '$199.99',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=gold%20lucky%20bracelet%20with%20chinese%20design&image_size=square',
        url: '#',
        tags: ['金', 'Metal', 'element:金', 'element:Metal', 'wealth', 'luck'],
        metafields: {
          element: 'Metal',
          bazi_element: '金',
          benefits: 'wealth',
          fortune_type: '财运提升',
          bazi_effect: ['财运提升'],
          bazi_wealth_luck: true,
          bazi_career_luck: false,
          bazi_love_luck: false,
          bazi_health_luck: false,
          bazi_current_year_luck: true
        }
      },
      {
        id: 'test-2',
        title: 'Green Wood Pendant',
        price: '$149.99',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=green%20wooden%20pendant%20with%20chinese%20carving&image_size=square',
        url: '#',
        tags: ['木', 'Wood', 'element:木', 'element:Wood', 'health', 'luck'],
        metafields: {
          element: 'Wood',
          bazi_element: '木',
          benefits: 'health',
          fortune_type: '健康平安',
          bazi_effect: ['健康平安'],
          bazi_wealth_luck: false,
          bazi_career_luck: false,
          bazi_love_luck: false,
          bazi_health_luck: true,
          bazi_current_year_luck: true
        }
      },
      {
        id: 'test-3',
        title: 'Blue Water Crystal',
        price: '$179.99',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=blue%20water%20crystal%20stone%20with%20chinese%20symbol&image_size=square',
        url: '#',
        tags: ['水', 'Water', 'element:水', 'element:Water', 'career', 'luck'],
        metafields: {
          element: 'Water',
          bazi_element: '水',
          benefits: 'career',
          fortune_type: '事业顺利',
          bazi_effect: ['事业顺利'],
          bazi_wealth_luck: false,
          bazi_career_luck: true,
          bazi_love_luck: false,
          bazi_health_luck: false,
          bazi_current_year_luck: true
        }
      },
      {
        id: 'test-4',
        title: 'Red Fire Necklace',
        price: '$159.99',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=red%20fire%20necklace%20with%20chinese%20design&image_size=square',
        url: '#',
        tags: ['火', 'Fire', 'element:火', 'element:Fire', 'love', 'luck'],
        metafields: {
          element: 'Fire',
          bazi_element: '火',
          benefits: 'love',
          fortune_type: '感情美满',
          bazi_effect: ['感情美满'],
          bazi_wealth_luck: false,
          bazi_career_luck: false,
          bazi_love_luck: true,
          bazi_health_luck: false,
          bazi_current_year_luck: true
        }
      },
      {
        id: 'test-5',
        title: 'Yellow Earth Ring',
        price: '$139.99',
        image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=yellow%20earth%20ring%20with%20chinese%20pattern&image_size=square',
        url: '#',
        tags: ['土', 'Earth', 'element:土', 'element:Earth', 'health', 'luck'],
        metafields: {
          element: 'Earth',
          bazi_element: '土',
          benefits: 'health',
          fortune_type: '健康平安',
          bazi_effect: ['健康平安'],
          bazi_wealth_luck: false,
          bazi_career_luck: false,
          bazi_love_luck: false,
          bazi_health_luck: true,
          bazi_current_year_luck: true
        }
      }
    ];
  }

  // 根据八字因素匹配产品
  matchProductsByBaziFactors(products, analysisResult, userData) {
    const { elementPreference, luckyColors, zodiac } = analysisResult;
    const { relationship } = userData;
    
    // 获取当前年份
    const currentYear = new Date().getFullYear().toString();
    
    // 存储推荐产品
    const recommendedProducts = [];
    const usedProductIds = new Set();
    const reasonCountMap = new Map();
    
    // 遍历所有产品，计算匹配度
    products.forEach(product => {
      if (usedProductIds.has(product.id)) return;
      
      let score = 0;
      const reasons = [];
      const uniqueReasons = new Set();
      
      // 从Metafields或标签中获取产品属性（智能合并后的数据）
      const productElement = this.getProductElement(product);
      const productEffects = this.getProductEffects(product);
      const productColors = this.getProductColors(product);
      const productStrength = this.getProductStrength(product);
      const productFavorableElements = this.getProductFavorableElements(product);
      const productUnfavorableElements = this.getProductUnfavorableElements(product);
      const productSuitableZodiacs = this.getProductSuitableZodiacs(product);
      const productSuitableYears = this.getProductSuitableYears(product);
      
      // 0. 首先检查忌用五行，如果匹配则直接跳过
      const hasUnfavorableElements = productUnfavorableElements.some(el => elementPreference.likes.includes(el));
      if (hasUnfavorableElements) {
        return; // 产品忌用五行匹配用户喜神，不推荐
      }
      
      // 1. 五行属性匹配 + 喜用五行匹配（合并判断，避免重复）
      const isElementMatch = elementPreference.likes.includes(productElement);
      const matchingFavorableElements = elementPreference.likes.filter(el => productFavorableElements.includes(el));
      
      if (isElementMatch || matchingFavorableElements.length > 0) {
        let elementReason;
        if (matchingFavorableElements.length > 0) {
          elementReason = `Accurately matches your lucky element(s) ${matchingFavorableElements.join('、')}`;
          score += matchingFavorableElements.length * 35;
        } else {
          elementReason = `Element ${productElement} matches your lucky element`;
          score += 40;
        }
        uniqueReasons.add(elementReason);
      }
      
      // 2. 功效属性匹配（智能合并后的数据，避免重复）
      if (productEffects.length > 0) {
        // 财运匹配
        if (productEffects.some(effect => effect.includes('财运') || effect === '财运提升' || effect.includes('wealth'))) {
          score += 30;
          uniqueReasons.add('Helps improve wealth luck');
        }
        
        // 事业运匹配
        if (productEffects.some(effect => effect.includes('事业') || effect === '事业顺利' || effect.includes('career'))) {
          score += 30;
          uniqueReasons.add('Helps with career development');
        }
        
        // 感情运匹配
        if (productEffects.some(effect => effect.includes('感情') || effect === '感情美满' || effect.includes('love'))) {
          score += 30;
          uniqueReasons.add('Helps improve relationship luck');
        }
        
        // 健康运匹配
        if (productEffects.some(effect => effect.includes('健康') || effect === '健康平安' || effect.includes('health'))) {
          score += 30;
          uniqueReasons.add('Helps improve health luck');
        }
        
        // 今年运势匹配
        if (productEffects.some(effect => effect.includes('今年') || effect === '今年运势' || effect.includes('current year')) || productSuitableYears.includes(currentYear)) {
          score += 25;
          uniqueReasons.add('Helps improve this year\'s luck');
        }
      }
      
      // 3. 幸运颜色匹配
      const matchingColors = productColors.filter(color => luckyColors.includes(color));
      if (matchingColors.length > 0) {
        score += matchingColors.length * 10;
        uniqueReasons.add(`Color(s) ${matchingColors.join('、')} are your lucky color(s)`);
      }
      
      // 4. 生肖匹配
      if (productSuitableZodiacs.includes(zodiac)) {
        score += 25;
        uniqueReasons.add(`Especially suitable for ${zodiac} zodiac`);
      }
      
      // 5. 关系状态匹配
      if (product.tags.some(tag => tag.toLowerCase().includes(relationship))) {
        score += 15;
        uniqueReasons.add('Suitable for your current relationship status');
      }
      
      // 6. 产品强度加权
      if (productStrength > 0) {
        const strengthBonus = (productStrength / 100) * 20; // 强度最多加20分
        score += strengthBonus;
        // 强度作为隐性加分，不显示为推荐理由
      }
      
      // 转换为数组，限制最多3个推荐理由
      const finalReasons = Array.from(uniqueReasons).slice(0, 3);
      
      // 只有匹配度大于0的产品才推荐
      if (score > 0 && finalReasons.length > 0) {
        // 检查同理由产品数量限制（最多3个）
        const mainReason = finalReasons[0];
        const reasonCount = reasonCountMap.get(mainReason) || 0;
        
        if (reasonCount < 3) {
          recommendedProducts.push({
            product,
            score,
            reasons: finalReasons
          });
          
          usedProductIds.add(product.id);
          reasonCountMap.set(mainReason, reasonCount + 1);
        }
      }
    });
    
    // 按匹配度排序
    recommendedProducts.sort((a, b) => b.score - a.score);
    
    // 返回前12个产品
    return recommendedProducts.slice(0, 12);
  }

  // 从产品中获取五行属性（智能合并新旧字段）
  getProductElement(product) {
    // 优先从新字段获取
    if (product.metafields && product.metafields.element) {
      return product.metafields.element;
    }
    // 兼容旧字段
    if (product.metafields && product.metafields.bazi_element) {
      return product.metafields.bazi_element;
    }
    // 从标签获取
    const elementTags = product.tags.filter(tag => 
      ['金', '木', '水', '火', '土', 'Metal', 'Wood', 'Water', 'Fire', 'Earth', 'element:金', 'element:木', 'element:水', 'element:火', 'element:土', 'element:Metal', 'element:Wood', 'element:Water', 'element:Fire', 'element:Earth'].includes(tag)
    );
    if (elementTags.length > 0) {
      const tag = elementTags[0].replace('element:', '');
      // 中文五行名称映射到英文
      const chineseToEnglishElement = {
        '金': 'Metal', '木': 'Wood', '水': 'Water', '火': 'Fire', '土': 'Earth'
      };
      return chineseToEnglishElement[tag] || tag;
    }
    return '';
  }

  // 从产品中获取功效属性（智能合并新旧字段）
  getProductEffects(product) {
    const effects = new Set();
    
    // 1. 从新的benefits字段获取
    if (product.metafields && product.metafields.benefits) {
      effects.add(product.metafields.benefits);
    }
    
    // 2. 从fortune_type字段获取
    if (product.metafields && product.metafields.fortune_type) {
      effects.add(product.metafields.fortune_type);
    }
    
    // 3. 兼容旧的bazi_effect字段
    if (product.metafields && product.metafields.bazi_effect) {
      const oldEffects = Array.isArray(product.metafields.bazi_effect) 
        ? product.metafields.bazi_effect 
        : [product.metafields.bazi_effect];
      oldEffects.forEach(effect => effects.add(effect));
    }
    
    // 4. 兼容旧的bazi_*_luck字段
    if (product.metafields) {
      if (product.metafields.bazi_wealth_luck) effects.add('财运提升');
      if (product.metafields.bazi_career_luck) effects.add('事业顺利');
      if (product.metafields.bazi_love_luck) effects.add('感情美满');
      if (product.metafields.bazi_health_luck) effects.add('健康平安');
      if (product.metafields.bazi_current_year_luck) effects.add('今年运势');
    }
    
    // 5. 从标签获取
    const effectTags = product.tags.filter(tag => tag.startsWith('effect:'));
    effectTags.forEach(tag => effects.add(tag.replace('effect:', '')));
    
    return Array.from(effects).filter(effect => effect.trim() !== '');
  }

  // 从产品中获取颜色属性（智能合并新旧字段）
  getProductColors(product) {
    const colors = new Set();
    
    // 1. 从新的lucky_color字段获取
    if (product.metafields && product.metafields.lucky_color) {
      colors.add(product.metafields.lucky_color);
    }
    
    // 2. 兼容旧的bazi_lucky_color字段
    if (product.metafields && product.metafields.bazi_lucky_color) {
      const oldColors = Array.isArray(product.metafields.bazi_lucky_color) 
        ? product.metafields.bazi_lucky_color 
        : [product.metafields.bazi_lucky_color];
      oldColors.forEach(color => colors.add(color));
    }
    
    // 3. 从标签获取
    const colorTags = product.tags.filter(tag => tag.startsWith('color:'));
    colorTags.forEach(tag => colors.add(tag.replace('color:', '')));
    
    return Array.from(colors).filter(color => color.trim() !== '');
  }

  // 从产品中获取喜用五行（智能合并新旧逻辑）
  getProductFavorableElements(product) {
    // 1. 从新的favorable_elements字段获取
    if (product.metafields && product.metafields.favorable_elements) {
      return product.metafields.favorable_elements.split(',').map(el => el.trim());
    }
    
    // 2. 兼容逻辑：如果没有明确的喜用五行，使用产品本身的五行
    const productElement = this.getProductElement(product);
    return productElement ? [productElement] : [];
  }

  // 从产品中获取忌用五行
  getProductUnfavorableElements(product) {
    if (product.metafields && product.metafields.unfavorable_elements) {
      return product.metafields.unfavorable_elements.split(',').map(el => el.trim());
    }
    return [];
  }

  // 从产品中获取适合的生肖
  getProductSuitableZodiacs(product) {
    if (product.metafields && product.metafields.suitable_for_zodiac) {
      return product.metafields.suitable_for_zodiac.split(',').map(zodiac => zodiac.trim());
    }
    return [];
  }

  // 从产品中获取适合的年份
  getProductSuitableYears(product) {
    const years = new Set();
    
    // 1. 从新的suitable_for_year字段获取
    if (product.metafields && product.metafields.suitable_for_year) {
      product.metafields.suitable_for_year.split(',').forEach(year => years.add(year.trim()));
    }
    
    // 2. 兼容逻辑：如果产品有current_year_luck标记，添加当前年份
    if (product.metafields && product.metafields.bazi_current_year_luck) {
      years.add(new Date().getFullYear().toString());
    }
    
    return Array.from(years);
  }

  // 从产品中获取产品强度
  getProductStrength(product) {
    if (product.metafields && product.metafields.strength) {
      return parseInt(product.metafields.strength) || 0;
    }
    return 0;
  }

  // 将推荐产品插入到分析结果中
  async insertRecommendationsIntoAnalysis(recommendedProducts, analysisResult) {
    // 如果没有推荐产品，跳过
    if (recommendedProducts.length === 0) {
      console.log('没有匹配的推荐产品');
      return;
    }
    
    // 为不同的分析部分分配推荐产品
    const wealthProducts = recommendedProducts.filter(item => 
      item.reasons.some(reason => reason.includes('wealth'))
    ).slice(0, 3);
    
    const careerProducts = recommendedProducts.filter(item => 
      item.reasons.some(reason => reason.includes('career'))
    ).slice(0, 3);
    
    const loveProducts = recommendedProducts.filter(item => 
      item.reasons.some(reason => reason.includes('relationship'))
    ).slice(0, 3);
    
    const healthProducts = recommendedProducts.filter(item => 
      item.reasons.some(reason => reason.includes('health'))
    ).slice(0, 3);
    
    const currentYearProducts = recommendedProducts.filter(item => 
      item.reasons.some(reason => reason.includes('current year'))
    ).slice(0, 3);
    
    // 插入到对应的分析部分
    this.insertProductsIntoSection('result-wealth-analysis', wealthProducts, 'Wealth Luck Recommended Products');
    this.insertProductsIntoSection('result-career-analysis', careerProducts, 'Career Luck Recommended Products');
    this.insertProductsIntoSection('result-love-analysis', loveProducts, 'Relationship Luck Recommended Products');
    this.insertProductsIntoSection('result-health-analysis', healthProducts, 'Health Luck Recommended Products');
    this.insertProductsIntoSection('result-current-year-analysis', currentYearProducts, 'Current Year Luck Recommended Products');
  }

  // 将产品插入到指定的分析部分
  insertProductsIntoSection(sectionId, products, title) {
    const sectionElement = document.getElementById(sectionId);
    if (!sectionElement || products.length === 0) return;
    
    // 创建产品推荐容器
    const recommendationContainer = document.createElement('div');
    recommendationContainer.className = 'bazi-recommendation-section';
    
    // 创建标题
    const sectionTitle = document.createElement('h6');
    sectionTitle.textContent = title;
    sectionTitle.style.cssText = `
      margin: 15px 0 10px 0;
      font-size: 14px;
      font-weight: 600;
      color: #333;
    `;
    recommendationContainer.appendChild(sectionTitle);
    
    // 创建产品网格
    const productGrid = document.createElement('div');
    productGrid.style.cssText = `
      display: flex;
      gap: 15px;
      overflow-x: auto;
      padding: 10px 0;
      scrollbar-width: thin;
    `;
    
    // 添加产品卡片
    products.forEach(({ product, reasons }) => {
      const productCard = this.createProductCard(product, reasons);
      productGrid.appendChild(productCard);
    });
    
    recommendationContainer.appendChild(productGrid);
    sectionElement.appendChild(recommendationContainer);
  }

  // 创建产品卡片
  createProductCard(product, reasons) {
    const card = document.createElement('div');
    card.className = 'bazi-product-card';
    card.style.cssText = `
      min-width: 140px;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      padding: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
      background-color: #24335f;
      box-shadow: 0 1px 3px #e0e0e0;
      display: flex;
      flex-direction: column;
      height: auto;
    `;
    
    // 产品图片
    const image = document.createElement('img');
    image.src = location.origin + "/cdn/shop/" + product.image;
    image.alt = product.title;
    image.className = 'bazi-product-image';
    image.style.cssText = `
      width: 100%;
      object-fit: cover;
      border-radius: 6px;
      margin-bottom: 10px;
      background-color: #24335f;
    `;
    
    // 产品信息
    const info = document.createElement('div');
    info.className = 'bazi-product-info';
    info.style.cssText = `
      font-size: 14px;
      flex: 1;
      display: flex;
      flex-direction: column;
    `;
    
    // 产品标题
    const title = document.createElement('h5');
    title.className = 'bazi-product-title';
    title.textContent = product.title;
    title.style.cssText = `
      margin: 0 0 8px 0;
      font-size: 14px;
      font-weight: 500;
      color: rgb(235, 162, 114);
      line-height: 1.4;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `;
    
    // 产品价格
    const price = document.createElement('p');
    price.className = 'bazi-product-price';
    price.textContent = product.price;
    price.style.cssText = `
      margin: 0 0 8px 0;
      font-size: 15px;
      font-weight: 600;
      color: rgb(255, 3, 3);
    `;
    
    // 推荐理由
    const reasonsElement = document.createElement('div');
    reasonsElement.className = 'bazi-product-reasons';
    reasonsElement.style.cssText = `
      font-size: 12px;
      margin-top: auto;
      padding-top: 8px;
      border-top: 1px solid rgb(235, 162, 114);
    `;
    
    reasons.forEach(reason => {
      const reasonP = document.createElement('p');
      reasonP.textContent = reason;
      reasonP.style.cssText = `
        margin: 0;
        color: rgb(235, 162, 114);
        line-height: 1.5;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      `;
      reasonsElement.appendChild(reasonP);
    });
    
    // 组装产品信息
    info.appendChild(title);
    info.appendChild(price);
    info.appendChild(reasonsElement);
    
    // 组装卡片
    card.appendChild(image);
    card.appendChild(info);
    
    // 添加点击事件
    card.addEventListener('click', () => {
      window.location.href = location.origin + "/" + (product.url || '/products/' + product.handle);
    });
    
    return card;
  }
}

// 初始化弹窗
const baziPopup = new BaziPopup();